import React, {
  useDebugValue,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import "./setupmeeting.css";

// -----------------------Components---------------------
import FileUpload from "../../Other/FileUpload";

// -----------------------Icons---------------------------
import { AiOutlineRight, AiOutlineClose } from "react-icons/ai";
import { BsSearch } from "react-icons/bs";
import Select from 'react-select'
import { MdOutlineWatchLater } from "react-icons/md";



// -----------------------Svgs---------------------------
import { ReactComponent as Recurring } from "../../../assets/Svg/Recurring.svg";

// -----------------------Packages------------------------
import DatePicker from "react-datepicker";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import Modal from "react-modal";
import { GET, LOGIN_POST, POST, PUT } from "../../Common/HttpMethods/HttpMethods";
import { Url } from "../../../constants/ApiUrlConstants";
import { useLocation } from "react-router-dom";
import { contextData } from "../../../context/ContextProvider";
import SuccessModal from "../../Common/Popups/SuccessModal";
import FailModal from "../../Common/Popups/FailModal";

import { GrPowerCycle } from "react-icons/gr";
import { FaArrowsRotate, FaAngleDown } from "react-icons/fa6";
import CreatableSelect from "react-select/creatable"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';
import { customStyles, customStylesMulti, Cuurent_EMAIL, Cuurent_USERNAME, getEmailClassification, nearestTime, stripHtmlTags } from "../../CommonCase/CommonFunctions";
// ------------------------Http Methods-------------------

export const validateInput = (name, value, setFormErrors) => {
  let field = name;
  let errorMessage = "";

  switch (name) {
    case "meetingSubject":
      let regexp = /^[A-Z]/;
      if (!value) {
        errorMessage = "Required.";
      } else if (/^\s/.test(value)) {
        errorMessage = "Input cannot have leading whitespace or be empty.";
      }

      break;
    case "staffIdTo":
      if (value?.length == 0) {
        errorMessage = "Required";
      }
      break;
    case "startDate":
    case "endDate":
    case "startTime":
    case "endTime":
    case "deptTagId":
    case "meetingLocation":
    case "complianceId":
      if (!value) {
        errorMessage = "Required";
      }
      break;
    case "controlRefMaster":
      if (value?.length == 0) {
        errorMessage = "Required";
      }
      break;
    case "meetingAgenda":
    case "message":
      const strippedValue = stripHtmlTags(value);

      if (!/^\S/.test(strippedValue) && strippedValue !== "") {
        errorMessage = "Input cannot have leading whitespace";
      }
      break;
    default:
      errorMessage = "";
      field = "";
  }
  setFormErrors((prevState) => ({ ...prevState, [name]: errorMessage }));
  return errorMessage;
};

export const handleOpenCloseRecurranceEnd = (
  recurranceEndDatePicker,
  setOpenRecurranceEndDatePicker,
  setOpenRecurranceStartDatePicker
) => {
  if (!recurranceEndDatePicker) {
    setOpenRecurranceEndDatePicker(true);
  }
  setOpenRecurranceStartDatePicker(false);
};


export const handleCloseFailModel = (setOpenFailModal,setFailMessage) => {
  setOpenFailModal(false);
  setFailMessage("");
};
export const navigateAfterSubmit = (navigate) => {
  navigate("/main/meetings/my-meetings");
};

export const handleOpenCloseRecurranceStart = (
  recurranceStartDatePicker,
  setOpenRecurranceStartDatePicker,
  setOpenRecurranceEndDatePicker
) => {
  if (!recurranceStartDatePicker) {
    setOpenRecurranceStartDatePicker(true);
  }
  setOpenRecurranceEndDatePicker(false);
};

export const fetchAllDropDownData = async ({
  setLoading,
  setDepartmentTags,
  setComplianceTags,
  setFormData,
  setTeams,
  setTeamsCopy,
  setLocations,
  setEmployeeData,
  setFilteredControllRef,
  setFilteredToEmployeeData,
  setFilteredOptionalEmployeeData,
  getMeetingDataById,
  setDisableRec,
  setSessionExpiredModal,
  setFailMessage,
  flow,
  token,
  Url,
  Email,
  formData,
  setFromForEdit,
  setEmailDetailId,
  setCreatedBy,
  setCreatedDate,
  setAllDaySelected,
  setActualData,
  setMonthlyRecDayVal,
  setDailyRecurrancePattern,
  setSelectAllWeekDays,
  setMonthlyRecurrancePattern,
  setYearlyRecurrancePattern,
  setRecPatternString,
  setRememberValues,
  monthNames,
  Currentdate,
  meetingId,
  GET,
  USERNAME,
  getEmailClassification,
  setOpenFailModal
}) => {
  try {
    setLoading(true);

    // Use Promise.all to make all API calls concurrently
    const [
      departmentTagResponse,
      complianceTagsResponse,
      employeesDataResponse,
      controlRefDataResponse,
      teamsDataResponse,
      locationResponse
    ] = await Promise.all([
      GET(Url.getDepartmentTags, token),
      GET(Url.getComplianceTags, token),
      GET(Url.getEmployees, token),
      GET(Url.getControlRef, token),
      GET(Url.getEmployeeListByProjectName, token),
      GET(Url.getMeetingLocationList, token)
    ]);

    if (controlRefDataResponse?.SUCCESS) {
      const changedData = controlRefDataResponse.DATA?.map((i) => ({ ...i, isSelected: false }));

      setDepartmentTags(departmentTagResponse?.DATA);
      setComplianceTags(complianceTagsResponse?.DATA);
      setFormData({ ...formData, controlRefMaster: changedData });

      let teamResp = teamsDataResponse?.DATA?.map((t) => {
        return {
          label: t?.projectName ? t?.projectName : t?.designation,
          value: t?.employeeMaster,
          isTeam: true
        };
      });

      setTeams(teamResp);
      setTeamsCopy(teamResp);

      if (locationResponse?.SUCCESS) {
        setLocations(locationResponse?.DATA);
      }

      // Setting employee data, removing login user
      const loggedInUserEmail = Email;
      const filteredEmployeeData = employeesDataResponse?.DATA?.filter((i) => i?.emailId !== loggedInUserEmail);
      let nd = employeesDataResponse?.DATA?.map((item) => {
        return {
          label: item.fullName,
          value: {
            emailDetailId: null,
            participantEmail: item?.emailId,
            emailTypeMaster: {
              emailTypeId: null
            }
          }
        };
      });

      let withoutTo = nd.filter((i) => {
        if (loggedInUserEmail !== i?.value?.participantEmail) {
          return i;
        }
      });

      setEmployeeData(filteredEmployeeData);
      setFilteredControllRef(changedData);
      setFilteredToEmployeeData(withoutTo);
      setFilteredOptionalEmployeeData(withoutTo);

      if (flow === "UpcomingMeetings" || flow === "CancelledMeetings") {
        getMeetingDataById(
          changedData,
          setLoading,
          setFromForEdit,
          setEmailDetailId,
          setCreatedBy,
          setCreatedDate,
          setAllDaySelected,
          setFilteredControllRef,
          setActualData,
          setMonthlyRecDayVal,
          setDailyRecurrancePattern,
          setSelectAllWeekDays,
          setMonthlyRecurrancePattern,
          setYearlyRecurrancePattern,
          setDisableRec,
          setRecPatternString,
          setRememberValues,
          monthNames,
          Currentdate,
          meetingId,
          token,
	        GET,
          Url,
          USERNAME,
          getEmailClassification,
 	        setFormData, 
          setSessionExpiredModal,
          setFailMessage,
          setOpenFailModal
        );
        setDisableRec(true);
      }

      setLoading(false);
    } else if (controlRefDataResponse.STATUS === 401) {
      // setSessionExpiredModal(true);
      // setFailMessage("Session expired");
      // setLoading(false);
      handleSessionExpiration(setSessionExpiredModal, setFailMessage, setLoading);

    } else {
      setLoading(false);
    }
  } catch (error) {
    console.error("Error in fetching dropdown data:", error);
    setLoading(false);
  }
};


export function calculateTimeDifferenceInner(
  startTime,
  endTime,
  formData,
  setFormData,
  formatTime2,
  isStartTimeGreaterThanEndTime,
  addOneDay
) {
  let innerStartDate = moment(formData.recStartDate, 'MM/DD/YYYY').format("MM/DD/YYYY");
  let innerEndDate = moment(formData.recEndDate, 'MM/DD/YYYY').format("MM/DD/YYYY");

  const startDate = moment(`${innerStartDate} ${startTime}`, 'MM/DD/YYYY hh:mm A');
  let endDate = moment(`${innerEndDate} ${endTime}`, 'MM/DD/YYYY hh:mm A');
  let timeDiff = endDate.diff(startDate, 'minutes');

  if (endDate.isBefore(startDate)) {
    timeDiff += 24 * 60;
  }

  const formattedDifference = formatTime2(timeDiff);
  const isEndTimeGreater = isStartTimeGreaterThanEndTime(startTime, endTime);

  if (isEndTimeGreater && (moment(formData.recStartDate).format("DD-MM-YYYY") === moment(formData.recEndDate).format("DD-MM-YYYY"))) {
    const nextDay = addOneDay(formData.recEndDate);

    setFormData((prevState) => ({
      ...prevState,
      recEndDate: nextDay,
      recDurationMinutes: formattedDifference,
    }));
  } else {
    setFormData((prevFormData) => ({
      ...prevFormData,
      recDurationMinutes: formattedDifference,
    }));
  }
}

export const calculateTimeDifferenceOuter = (
  startTime,
  endTime,
  formData,
  setFormData,
  formatTime2,
  isStartTimeGreaterThanEndTime,
  addOneDay
) => {
  let outerStartDate = moment(formData.startDate, 'MM/DD/YYYY').format("MM/DD/YYYY");
  let outerEndDate = moment(formData.endDate, 'MM/DD/YYYY').format("MM/DD/YYYY");
  const startDate = moment(`${outerStartDate} ${startTime}`, 'MM/DD/YYYY hh:mm A');
  let endDate = moment(`${outerEndDate} ${endTime}`, 'MM/DD/YYYY hh:mm A');

  let timeDiff = endDate.diff(startDate, 'minutes');
  if (endDate.isBefore(startDate)) {
    timeDiff += 24 * 60;
  }
  const formattedDifference = formatTime2(timeDiff);

  const isEndTimeGrater = isStartTimeGreaterThanEndTime(startTime, endTime);
  if (
    isEndTimeGrater &&
    moment(formData.startDate).format("DD-MM-YYYY") === moment(formData.endDate).format("DD-MM-YYYY")
  ) {
    const nextDay = addOneDay(formData.endDate);
    setFormData((prevState) => ({
      ...prevState,
      endDate: nextDay,
      DurationMinutes: formattedDifference,
    }));
  } else {
    setFormData((prevFormData) => ({
      ...prevFormData,
      DurationMinutes: formattedDifference,
    }));
  }
};

export const handleCreateOption = (
  inputTime,
  type,
  TimeArray,
  formData,
  setFormData,
  handleFormChange,
  setIndexOfStartTimeOuter,
  addMoreHalfHours,
  calculateTimeDifferenceOuter,
  calculateTimeDifferenceInner,
  formatTime2,
  isStartTimeGreaterThanEndTime,
  addOneDay,
  handleCloseControllRefDropdown,
  Email,
  filteredOptionalEmployeeData,
  selectAllChecked,
  setFilteredControllRef,
  setDailyRecurrancePattern,
  monthNames,
  Currentdate,
  setRecurranceErrors,
  setMonthlyRecDayVal,
  dailyRecurrancePattern,
  setAllDaySelected,
  setFormErrors,
  setFailMessage,
  setOpenFailModal,
  validateInput,
  isControlRefOpened
) => {
  const regEx = /^(?:1[0-2]|0?[1-9]):[0-5][0-9] (AM|PM)$/;

 
  const inputValue = inputTime;
  handleCloseControllRefDropdown();

  if (regEx.test(inputTime)) {
    switch (type) {
      case "outerStartTime":
       
        setIndexOfStartTimeOuter(TimeArray.indexOf(inputValue));

        let d = TimeArray?.indexOf(inputValue) === TimeArray?.length - 1
          ? { label: TimeArray[0], value: TimeArray[0], isDisabled: false }
          : { label: TimeArray[TimeArray.indexOf(inputValue) + 1], value: TimeArray[TimeArray.indexOf(inputValue) + 1], isDisabled: false };

        setFormData({ ...formData, endTime: d });
        handleFormChange("startTime", { label: inputValue, value: inputValue, isDisabled: false },
          formData,
          Email,
          setFormData,
          filteredOptionalEmployeeData,
          selectAllChecked,
          setFilteredControllRef,
          setDailyRecurrancePattern,
          monthNames,
          Currentdate,
          setRecurranceErrors,
          setMonthlyRecDayVal,
          dailyRecurrancePattern,
          setAllDaySelected,
          setFormErrors,
          setFailMessage,
          setOpenFailModal,
          isStartTimeGreaterThanEndTime,
          validateInput,
          isControlRefOpened
        );

        const endTimeAfterAddingHalfHour = addMoreHalfHours(inputValue);
        handleFormChange("endTime", { label: endTimeAfterAddingHalfHour, value: endTimeAfterAddingHalfHour, isDisabled: false });

        calculateTimeDifferenceOuter(
          inputValue,
          endTimeAfterAddingHalfHour,
          formData,
          setFormData,
          formatTime2,
          isStartTimeGreaterThanEndTime,
          addOneDay
        );
        break;

      case "outerEndTime":
        handleFormChange("endTime", { label: inputValue, value: inputValue, isDisabled: false });
        calculateTimeDifferenceOuter(
          formData?.startTime?.value,
          inputValue,
          formData,
          setFormData,
          formatTime2,
          isStartTimeGreaterThanEndTime,
          addOneDay
        );
        break;

      case "recurranceStartTime":
        setIndexOfStartTimeOuter(TimeArray.indexOf(inputValue));

        let dinner = TimeArray.indexOf(inputValue) === TimeArray.length - 1
          ? { label: TimeArray[0], value: TimeArray[0], isDisabled: false }
          : { label: TimeArray[TimeArray.indexOf(inputValue) + 1], value: TimeArray[TimeArray.indexOf(inputValue) + 1], isDisabled: false };

        setFormData({ ...formData, recEndTime: dinner });
        handleFormChange("recStartTime", { label: inputValue, value: inputValue, isDisabled: false });

        const endTimeAfterAddingHalfHourInner = addMoreHalfHours(inputValue);
        handleFormChange("recEndTime", { label: endTimeAfterAddingHalfHourInner, value: endTimeAfterAddingHalfHourInner, isDisabled: false });

        calculateTimeDifferenceInner(
          inputValue,
          endTimeAfterAddingHalfHourInner,
          formData,
          setFormData,
          formatTime2,
          isStartTimeGreaterThanEndTime,
          addOneDay
        );
        break;

      case "recurranceEndTime":
        handleFormChange("recEndTime", { label: inputValue, value: inputValue, isDisabled: false });
        calculateTimeDifferenceInner(
          formData?.recStartTime?.value,
          inputValue,
          formData,
          setFormData,
          formatTime2,
          isStartTimeGreaterThanEndTime,
          addOneDay
        );
        break;
    }
  }
};


export const handleControllRefSearch = (e, setControllFilterInp, formData, setFilteredControllRef) => {
  const { value } = e.target;
  setControllFilterInp(value);

  const Tofiltered = [...formData.controlRefMaster];

  const filtered = Tofiltered?.filter((item) => {
    const arrField = item?.controlRefShort?.toLowerCase();
    const crefno = item?.controlRefNo.toString();
    return arrField.includes(value?.toLowerCase()) || crefno.includes(value?.toLowerCase());
  });

  setFilteredControllRef(filtered);
};


export const handleDropdownToggleRec = (RcurDropdownOpen, setRcurDropdownOpen, setRcurDropdownOpen2) => {
  setRcurDropdownOpen(!RcurDropdownOpen);
  setRcurDropdownOpen2(false);
};

export const handleDropdownToggle2Rec = (RcurDropdownOpen2, setRcurDropdownOpen2, setRcurDropdownOpen) => {
  setRcurDropdownOpen2(!RcurDropdownOpen2);
  setRcurDropdownOpen(false);
};


export const handle_daily_recurrance_type = (
  e,
  setDailyRecurrancePattern,
  setFormData
) => {
  const { value, name } = e.target;
  setDailyRecurrancePattern(value);
  setFormData((prevState) => ({ ...prevState, recRecurrenceInterval: 0 }));
};


export const addMoreHalfHours = (inputTime) => {
  const format = 'hh:mm A';
  const parsedTime = moment(inputTime, format);
  const resultTime = parsedTime.add(1 * 30, 'minutes');
  return resultTime.format(format);
};

export const closeModal = (setIsOpen) => {
  setIsOpen(false);
};

export const handleSelectAll = (setSelectAllChecked,selectAllChecked) => {
  setSelectAllChecked(!selectAllChecked);
};


export const addOneDay = (inputDate) => {
  // Parse the input date with the specified format
  const formattedDate = moment(inputDate, 'DD-MM-YYYY');
  // Add one day
  const newDate = formattedDate.add(1, 'days');
  const result = newDate.format('YYYY-MM-DD');
  return new Date(result);
};

export const formatTime2 = (minutes) => {
  let hours = Math.floor(minutes / 60);
  if (hours >= 24) {
    hours = hours % 24; // Ensure hours are within 24
  }
  const remainingMinutes = minutes % 60;
  return `${String(hours).padStart(2, '0')}h:${String(remainingMinutes).padStart(2, '0')}m`;
};


export const handle_monthly_recurrance_type = (
  e,
  monthlyTab,
  setMonthlyRecurrancePattern,
  setFormData,
  setMonthlyRecDayVal
) => {
  const { value, name } = e.target;
  let weeoNumberID = "";
  const obj = {
    isMonday: false,
    isTuesday: false,
    isWednesday: false,
    isThursday: false,
    isFriday: false,
    isSaturday: false,
    isSunday: false,
  };

  if (monthlyTab === "monthlySecondTab") {
    obj.isSunday = true;
    weeoNumberID = "First";
  }

  setMonthlyRecurrancePattern(value);
  setFormData((prevState) => ({
    ...prevState,
    recRecurrenceInterval: 0,
    recDayOfMonth: "",
    recWeekNoId: weeoNumberID,
    recDays: obj,
  }));
  setMonthlyRecDayVal("");
};


export const handle_yearly_recurrance_type = (
  e,
  yearsTab,
  setYearlyRecurrancePattern,
  setFormData,
  setMonthlyRecDayVal
) => {
  const obj = {
    isMonday: false,
    isTuesday: false,
    isWednesday: false,
    isThursday: false,
    isFriday: false,
    isSaturday: false,
    isSunday: false,
  };

  const { value, name } = e.target;
  let weeoNumberID = null;

  if (yearsTab === "YearSecondTab") {
    obj.isSunday = true;
    weeoNumberID = "First";
  }

  setYearlyRecurrancePattern(value);
  setFormData((prevState) => ({
    ...prevState,
    recDays: obj,
    recWeekNoId: weeoNumberID,
    recDayOfMonth: "",
    recMonthOfYear: "January",
  }));
  setMonthlyRecDayVal("");
};


export const handleRefChange = (
  id,
  handleFormChange,
  setControllRefOpened,
  formData,
  Email,
  setFormData,
  filteredOptionalEmployeeData,
  setFilteredToEmployeeData,
  selectAllChecked,
  setFilteredControllRef,
  setDailyRecurrancePattern,
  monthNames,
  Currentdate,
  setRecurranceErrors,
  setMonthlyRecDayVal,
  dailyRecurrancePattern,
  setAllDaySelected,
  setFormErrors,
  setFailMessage,
  setOpenFailModal,
  isStartTimeGreaterThanEndTime,
  validateInput,
  isControlRefOpened
) => {
  handleFormChange("controlRefMaster", id);
  setControllRefOpened(true);
};

export const handleRemoveControllRef = (
  id,
  setFilteredControllRef,
  setFormData,
  filteredControllRef,
  formData
) => {
  setFilteredControllRef(
    filteredControllRef?.map((i) => {
      if (i.controlRefId == id) {
        return { ...i, isSelected: false };
      } else {
        return i;
      }
    })
  );

  const prevState = [...formData.controlRefMaster];
  const newState = prevState.map((i, index) => {
    if (i.controlRefId == id) {
      return { ...i, isSelected: false };
    } else {
      return i;
    }
  });

  setFormData((prevData) => ({ ...prevData, controlRefMaster: newState }));
};


export const handlerecurranceClose = (
  recRememberValues,
  setRecurringPop,
  setFormData,
  setRecurranceErrors,
  formData,
  monthNames,
  Currentdate,
  recPatternString
) => {
  const { startDate, endDate, startTime, endTime, recurrenceType, isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday, recurrenceInterval, weekNoId, dayOfMonth, monthOfYear, duration } = recRememberValues;

  setRecurringPop(false);

  if (!recPatternString) {
    setFormData((prevState) => ({
      ...prevState,
      // recurring----------------------
      recStartTime: formData.isAllDay ? { label: "12:00 AM", value: "12:00 AM" } : "",
      recEndTime: formData.isAllDay ? { label: "12:00 AM", value: "12:00 AM" } : "",
      recStartDate: new Date(),
      recEndDate: new Date(+new Date() + 86400000),
      recRecurrenceType: "Daily",
      recRecurrenceInterval: 0,
      recDurationMinutes: formData.isAllDay ? "24h : 00m" : "00h : 00m",
      recDays: {
        isMonday: false,
        isTuesday: false,
        isWednesday: false,
        isThursday: false,
        isFriday: false,
        isSaturday: false,
        isSunday: false,
      },
      recWeekNoId: "",
      recDayOfMonth: "",
      recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
    }));
  } else {
    setFormData((prevState) => ({
      ...prevState,
      // recurring----------------------
      recStartTime: startTime,
      recEndTime: endTime,
      recStartDate: startDate,
      recEndDate: endDate,
      recRecurrenceType: recurrenceType,
      recRecurrenceInterval: recurrenceInterval,
      recDurationMinutes: duration,
      recDays: {
        isMonday: isMonday,
        isTuesday: isTuesday,
        isWednesday: isWednesday,
        isThursday: isThursday,
        isFriday: isFriday,
        isSaturday: isSaturday,
        isSunday: isSunday,
      },
      recWeekNoId: weekNoId,
      recDayOfMonth: dayOfMonth,
      recMonthOfYear: monthOfYear,
    }));
  }

  setRecurranceErrors({
    recStartTime: "",
    recEndTime: "",
    recStartDate: "",
    recEndDate: "",
    recRecurrenceType: "",
    recRecurrenceInterval: "",
    recDays: "",
    recWeekNoId: "",
    recDayOfMonth: "",
    recMonthOfYear: "",
    recDurationMinutes: "",
    DurationMinutes: "",
  });
};

export const handleFormKeyDown = (e) => {
  if (e.key === "Enter") {
    if (e.target.tagName.toLowerCase() === 'textarea') {
      return;
    }
    e.preventDefault();
  }
}

export const handleOutsideClick = (crefContainerRef, setOpenControlRefDropDown) => (e) => {
  if (crefContainerRef.current && !crefContainerRef.current.contains(e.target)) {
    setOpenControlRefDropDown(false);
  }
};


export const handleClickOutside = (event, newRef, newRef2, setDropdownOpen, setDropdownOpen2) => {
  const isOutsideDropdowns = !newRef.current?.contains(event.target) && !newRef2.current?.contains(event.target);
  if (isOutsideDropdowns) {
    setDropdownOpen(false);
    setDropdownOpen2(false);
  }
};

export const handleClickOutside2 = (event, RecRef, RecRef2, setRcurDropdownOpen, setRcurDropdownOpen2) => {
  const isRecOutsideDropdowns = !RecRef.current?.contains(event.target) && !RecRef2.current?.contains(event.target);
  if (isRecOutsideDropdowns) {
    setRcurDropdownOpen(false);
    setRcurDropdownOpen2(false);
  }
};


export const handle_rec_start_date = (
  date,
  handleFormChange,
  setOpenRecurranceStartDatePicker,
  formData,
  Email,
  setFormData,
  filteredOptionalEmployeeData,
  setFilteredToEmployeeData,
  selectAllChecked,
  setFilteredControllRef,
  setDailyRecurrancePattern,
  monthNames,
  Currentdate,
  setRecurranceErrors,
  setMonthlyRecDayVal,
  dailyRecurrancePattern,
  setAllDaySelected,
  setFormErrors,
  setFailMessage,
  setOpenFailModal,
  isStartTimeGreaterThanEndTime,
  validateInput,
  isControlRefOpened
) => {
  handleFormChange("recStartDate", date);
  handleFormChange("recEndDate", date);
  setOpenRecurranceStartDatePicker(false);
};

export const handle_rec_end_date = (
  date,
  handleFormChange,
  setOpenRecurranceEndDatePicker,
  formData,
  Email,
  setFormData,
  filteredOptionalEmployeeData,
  setFilteredToEmployeeData,
  selectAllChecked,
  setFilteredControllRef,
  setDailyRecurrancePattern,
  monthNames,
  Currentdate,
  setRecurranceErrors,
  setMonthlyRecDayVal,
  dailyRecurrancePattern,
  setAllDaySelected,
  setFormErrors,
  setFailMessage,
  setOpenFailModal,
  isStartTimeGreaterThanEndTime,
  validateInput,
  isControlRefOpened
) => {
  handleFormChange("recEndDate", date);
  setOpenRecurranceEndDatePicker(false);
};

export const handleSelectAllDays = (
  formData,
  setFormData,
  validateRecurrance,
  dailyRecurrancePattern,
  setRecurranceErrors
) => {
  let { isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday } = formData?.recDays;

  let selAll;

  if (isMonday && isTuesday && isWednesday && isThursday && isFriday && isSaturday && isSunday) {
    selAll = false;
  } else {
    selAll = true;
  }

  const obj = {
    isMonday: selAll,
    isTuesday: selAll,
    isWednesday: selAll,
    isThursday: selAll,
    isFriday: selAll,
    isSaturday: selAll,
    isSunday: selAll,
  };

  validateRecurrance("recDays", obj, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);

  setFormData((PrevState) => ({ ...PrevState, recDays: { ...obj } }));
};


export const handleOkRecurrence = async ({
  formData,
  monthlyRecurrancePattern,
  yearlyRecurrancePattern,
  weekGaps,
  monthNames,
  token,
  Url,
  setIsRecurranceSelected,
  setFormErrors,
  setRememberValues,
  setRecPatternString,
  handlerecurranceCloseOk,
  validateRecurrance, dailyRecurrancePattern, setRecurranceErrors
}) => {
  let isValidForm = true;
  const recErrors = [];
  const {
    recStartTime,
    recEndTime,
    recStartDate,
    recEndDate,
    recRecurrenceType,
    recRecurrenceInterval,
    recDays,
    recWeekNoId,
    recDayOfMonth,
    recMonthOfYear,
    recDurationMinutes,
  } = formData;

  const recStartTimeErrr = validateRecurrance("recStartTime", recStartTime, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);

  const recEndTimeErrr = validateRecurrance("recEndTime", recEndTime, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);
  const recRecurrenceIntervalErrr = validateRecurrance("recRecurrenceInterval", recRecurrenceInterval, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);
  let recDaysError;
  let recDayOfMonthError;

  // to valid recurrence another field
  if (recRecurrenceType === "Weekly") {
    recDaysError = validateRecurrance("recDays", recDays, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);
    recErrors.push(recDaysError);
  } else if (recRecurrenceType === "Monthly" && monthlyRecurrancePattern === "EveryDay") {
    recDayOfMonthError = validateRecurrance("recDayOfMonth", recDayOfMonth, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);
    recErrors.push(recDayOfMonthError);
  } else if (recRecurrenceType === "Yearly" && yearlyRecurrancePattern === "YearFirstTab") {
    recDayOfMonthError = validateRecurrance("recDayOfMonth", recDayOfMonth, "onSubmit", dailyRecurrancePattern, setRecurranceErrors);
    recErrors.push(recDayOfMonthError);
  }

  recErrors.push(recStartTimeErrr);
  recErrors.push(recEndTimeErrr);
  recErrors.push(recRecurrenceIntervalErrr);

  recErrors.forEach((error) => {
    if (error !== "") {
      isValidForm = false;
    }
  });

  // After pressing Ok;
  if (isValidForm) {
    setIsRecurranceSelected(true);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    }));

    const {
      isMonday,
      isTuesday,
      isThursday,
      isWednesday,
      isFriday,
      isSaturday,
      isSunday,
    } = formData?.recDays;

    let body = {
      startDate: moment(recStartDate).format("YYYY-MM-DD"),
      endDate: moment(recEndDate).format("YYYY-MM-DD"),
      startTime: recStartTime?.value,
      endTime: recEndTime?.value,
      recurrenceType: recRecurrenceType,
      isMonday: isMonday === true ? "Y" : "N",
      isTuesday: isTuesday === true ? "Y" : "N",
      isWednesday: isWednesday === true ? "Y" : "N",
      isThursday: isThursday === true ? "Y" : "N",
      isFriday: isFriday === true ? "Y" : "N",
      isSaturday: isSaturday === true ? "Y" : "N",
      isSunday: isSunday === true ? "Y" : "N",
      recurrenceInterval: parseInt(recRecurrenceInterval),
      weekNoId: recWeekNoId ? weekGaps.indexOf(recWeekNoId) + 1 : null,
      dayOfMonth: recDayOfMonth ? parseInt(recDayOfMonth) : null,
      monthOfYear: monthNames.indexOf(recMonthOfYear) + 1,
      duration: recDurationMinutes,
    };

    let RecString = await POST(Url.getRecurranceInfoStatmt, token, body);

    setRememberValues({
      startDate: recStartDate,
      endDate: recEndDate,
      startTime: recStartTime,
      endTime: recEndTime,
      recurrenceType: recRecurrenceType,
      isMonday,
      isTuesday,
      isWednesday,
      isThursday,
      isFriday,
      isSaturday,
      isSunday,
      recurrenceInterval: parseInt(recRecurrenceInterval),
      weekNoId: recWeekNoId ? weekGaps.indexOf(recWeekNoId) + 1 : null,
      dayOfMonth: recDayOfMonth ? parseInt(recDayOfMonth) : null,
      monthOfYear: monthNames.indexOf(recMonthOfYear) + 1,
      duration: recDurationMinutes,
    });

    setRecPatternString(RecString?.recuranceinfo);
    handlerecurranceCloseOk();
  }
};

export const getMeetingDataById = async (crdata, setLoading, setFromForEdit, setEmailDetailId, setCreatedBy, setCreatedDate, setAllDaySelected, setFilteredControllRef, setActualData, setMonthlyRecDayVal, setDailyRecurrancePattern, setSelectAllWeekDays, setMonthlyRecurrancePattern, setYearlyRecurrancePattern, setDisableRec, setRecPatternString, setRememberValues, monthNames, Currentdate, meetingId, token, GET, Url, USERNAME, getEmailClassification, setFormData, setSessionExpiredModal, setFailMessage, setOpenFailModal) => {
  setLoading(true);
  try {


    let GetEditMeetingDataResp = await GET(
      Url.GetMeetingDetailsById.replace("{mid}", meetingId),
      token
    );

    if (GetEditMeetingDataResp.SUCCESS) {

      let {
        startDate,
        endDate,
        appointmentRecurrence,
        attachmentDocuments,
        complianceTagsMaster,
        controlRefMaster,
        deptartmentTagMaster,
        duration,
        emailDetails,
        emailDetail,
        endTime,
        isAllDay,
        meetingAgenda,
        meetingLocation,
        meetingStatus,
        meetingSubject,
        message,
        mid,
        startTime,
        createdDate,
        createdBy
      } = GetEditMeetingDataResp?.DATA;




      //////////////////////////////////////////////SET TO FROM OPTIONAL///////////////////////////////////






      const classification = getEmailClassification(emailDetail);


      let toEditArr = classification.to;
      let fromEditArr = classification.from;
      let optionalEditArr = classification.optional




      setFromForEdit(fromEditArr)



      setEmailDetailId(fromEditArr[0]?.emailDetailId)

      setCreatedBy(createdBy)
      setCreatedDate(createdDate)

      let allDaySet = isAllDay == "Y" ? true : false
      setAllDaySelected(allDaySet)



      let from = fromEditArr[0]?.employeeMaster?.fullName ? fromEditArr[0]?.employeeMaster?.fullName : USERNAME;
      let to = toEditArr.length > 0 ? toEditArr?.map((i) => { return { label: i?.employeeMaster?.fullName, value: i } }) : [];
      let optional = optionalEditArr.length > 0 ? optionalEditArr?.map((i) => { return { label: i?.employeeMaster?.fullName, value: i } }) : []


      //////////////////////////////////////////////SET CONTROL REF///////////////////////////////////

      let toCheck = controlRefMaster?.map((i) => {
        return i.controlRefId;
      });

      let editedCrData = crdata?.map((item) => {
        if (toCheck.includes(item?.controlRefId)) {
          return { ...item, isSelected: true };
        } else {
          return item;
        }
      });

      setFilteredControllRef(editedCrData);

      //////////////////////////////////////////////SET ATTACHMENTS////////////////////////////////////////

      let actuleFileData = [];
      let editFileData = [];

      attachmentDocuments?.map((f) => {
        actuleFileData.push({
          name: f.fileName,
          fileType: f.fileType,
          attachment: f.attachment,
          attachmentDocId: f.attachmentDocId
        });

        editFileData.push({
          fileName: f.fileName,
          fileType: f.fileType,
          attachment: f.attachment,
          attachmentDocId: f.attachmentDocId
        });
      });

      setActualData([...actuleFileData]);

      ///////////////////////////SET RECURRENCE PATTERN STATES FOR EDIT////////////////////////////////////////
      // appointmentRecurrence?.recurrenceType
      const callbacks = {
        setDailyRecurrancePattern,
        setSelectAllWeekDays,
        setMonthlyRecurrancePattern,
        setRecurrenceDayVal,
        setMonthlyRecDayVal,
        setYearlyRecurrancePattern,
      };


      let finnalRecurranceToset;
      if (appointmentRecurrence) {
        finnalRecurranceToset = {
          recStartTime: { label: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.startTime, value: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.startTime, isDisabled: false },
          recEndTime: { label: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.endTime, value: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.endTime, isDisabled: false },
          recDurationMinutes: appointmentRecurrence?.duration ? appointmentRecurrence?.duration : "00h:00m",
          recRecurrenceType: handleRecurrencePattern(appointmentRecurrence, callbacks),
          recRecurrenceInterval: appointmentRecurrence?.recurrenceInterval,
          recDayOfWeek: null,
          recDayOfMonth: appointmentRecurrence?.dayOfMonth,
          recWeekNoId:
            appointmentRecurrence?.weekNoId == 1
              ? "First"
              : appointmentRecurrence?.weekNoId == 2
                ? "Second"
                : appointmentRecurrence?.weekNoId == 3
                  ? "Third"
                  : appointmentRecurrence?.weekNoId == 4
                    ? "Fourth"
                    : appointmentRecurrence?.weekNoId == 5
                      ? "Fifth"
                      : "",
          recMonthOfYear: `${monthNames[appointmentRecurrence?.monthOfYear - 1]
            }`,
          // ----------------------------Need to change the recStartDate and  recEndDate-
          recStartDate: new Date(
            `${appointmentRecurrence?.startDate[0]}-${appointmentRecurrence?.startDate[1]}-${appointmentRecurrence?.startDate[2]}`
          ),
          recEndDate: new Date(
            `${appointmentRecurrence?.endDate[0]}-${appointmentRecurrence?.endDate[1]}-${appointmentRecurrence?.endDate[2]}`
          ),
          recDays: {
            isMonday:
              appointmentRecurrence?.isMonday == "N" ||
                !appointmentRecurrence?.isMonday
                ? false
                : true,
            isTuesday:
              appointmentRecurrence?.isTuesday == "N" ||
                !appointmentRecurrence?.isTuesday
                ? false
                : true,
            isWednesday:
              appointmentRecurrence?.isWednesday == "N" ||
                !appointmentRecurrence?.isWednesday
                ? false
                : true,
            isThursday:
              appointmentRecurrence?.isThursday == "N" ||
                !appointmentRecurrence?.isThursday
                ? false
                : true,
            isFriday:
              appointmentRecurrence?.isFriday == "N" ||
                !appointmentRecurrence?.isFriday
                ? false
                : true,
            isSaturday:
              appointmentRecurrence?.isSaturday == "N" ||
                !appointmentRecurrence?.isSaturday
                ? false
                : true,
            isSunday:
              appointmentRecurrence?.isSunday == "N" ||
                !appointmentRecurrence?.isSunday
                ? false
                : true,
          },
        }
      }
      else {
        setDisableRec(false)

        finnalRecurranceToset = {
          recStartTime: { label: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.startTime, value: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.startTime, isDisabled: false },
          recEndTime: { label: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.endTime, value: isAllDay == "Y" ? "12:00 AM" : appointmentRecurrence?.endTime, isDisabled: false },
          recStartDate: new Date(),
          recEndDate: new Date(+new Date() + 86400000),
          recRecurrenceType: "Daily",
          recRecurrenceInterval: 0,
          recDays: {
            isMonday: false,
            isTuesday: false,
            isWednesday: false,
            isThursday: false,
            isFriday: false,
            isSaturday: false,
            isSunday: false,
          },
          recWeekNoId: "",
          recDayOfMonth: "",
          recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
          recDurationMinutes: isAllDay ? "24h : 00m" : "00h : 00m",
        }
      }
      let dataToSetEditInfo = {
        staffIdFrom: from,
        meetingSubject: meetingSubject,
        staffIdTo: [...to],
        staffIdOptional: [...optional],
        // main fields---
        startDate: new Date(
          `${startDate[0]}-${startDate[1]}-${startDate[2]}`
        ),
        endDate: new Date(`${endDate[0]}-${endDate[1]}-${endDate[2]}`),
        startTime: { label: isAllDay == "Y" ? "12:00 AM" : startTime, value: isAllDay == "Y" ? "12:00 AM" : startTime, isDisabled: false },
        endTime: { label: isAllDay == "Y" ? "12:00 AM" : endTime, value: isAllDay == "Y" ? "12:00 AM" : endTime, isDisabled: false },
        isAllDay: isAllDay == "Y" ? true : false,
        timeZone: "UTC+5:30",
        DurationMinutes: duration,
        // recurring
        // ----------------------------Need to change the recStartTime and  recEndTime-
        ...finnalRecurranceToset,
        // rec end
        deptTagId: deptartmentTagMaster.deptTagId,
        meetingLocation: meetingLocation?.locationId,
        complianceId: complianceTagsMaster.complianceId,
        controlRefMaster: [...editedCrData],
        meetingAgenda: meetingAgenda,
        message: message,
        attachmentDocuments: [...editFileData],
        mid: mid,
      };



      if (appointmentRecurrence?.recurrenceStmt) {

        setRecPatternString(appointmentRecurrence?.recurrenceStmt);


        //setting this field to remember recurrance values while closing
        setRememberValues({
          startTime: { label: appointmentRecurrence?.startTime, value: appointmentRecurrence?.startTime, isDisabled: false },
          endTime: { label: appointmentRecurrence?.endTime, value: appointmentRecurrence?.endTime, isDisabled: false },
          duration: appointmentRecurrence?.duration ? appointmentRecurrence?.duration : "00h:00m",
          recurrenceType: handleRecurrencePattern(appointmentRecurrence, callbacks),
          recurrenceInterval: appointmentRecurrence?.recurrenceInterval,
          dayOfMonth: appointmentRecurrence?.dayOfMonth,
          weekNoId:
            appointmentRecurrence?.weekNoId == 1
              ? "First"
              : appointmentRecurrence?.weekNoId == 2
                ? "Second"
                : appointmentRecurrence?.weekNoId == 3
                  ? "Third"
                  : appointmentRecurrence?.weekNoId == 4
                    ? "Fourth"
                    : appointmentRecurrence?.weekNoId == 5
                      ? "Fifth"
                      : "",
          monthOfYear: `${monthNames[appointmentRecurrence?.monthOfYear - 1]
            }`,
          // ----------------------------Need to change the recStartDate and  recEndDate-
          startDate: new Date(
            `${appointmentRecurrence?.startDate[0]}-${appointmentRecurrence?.startDate[1]}-${appointmentRecurrence?.startDate[2]}`
          ),
          endDate: new Date(
            `${appointmentRecurrence?.endDate[0]}-${appointmentRecurrence?.endDate[1]}-${appointmentRecurrence?.endDate[2]}`
          ),
          recDays: {
            isMonday:
              appointmentRecurrence?.isMonday == "N" ||
                !appointmentRecurrence?.isMonday
                ? false
                : true,
            isTuesday:
              appointmentRecurrence?.isTuesday == "N" ||
                !appointmentRecurrence?.isTuesday
                ? false
                : true,
            isWednesday:
              appointmentRecurrence?.isWednesday == "N" ||
                !appointmentRecurrence?.isWednesday
                ? false
                : true,
            isThursday:
              appointmentRecurrence?.isThursday == "N" ||
                !appointmentRecurrence?.isThursday
                ? false
                : true,
            isFriday:
              appointmentRecurrence?.isFriday == "N" ||
                !appointmentRecurrence?.isFriday
                ? false
                : true,
            isSaturday:
              appointmentRecurrence?.isSaturday == "N" ||
                !appointmentRecurrence?.isSaturday
                ? false
                : true,
            isSunday:
              appointmentRecurrence?.isSunday == "N" ||
                !appointmentRecurrence?.isSunday
                ? false
                : true,
          },
        })
      }
      setFormData(dataToSetEditInfo);
      setLoading(false);
    } else if (GetEditMeetingDataResp.STATUS == 401) {
      handleSessionExpiration(setSessionExpiredModal, setFailMessage, setLoading);

    }
    else {

      setLoading(false);
      setFailMessage("Failed To Fetch Meeting Data");
      setOpenFailModal(true);
    }
  } catch (error) {

    setLoading(false);
    setFailMessage("Failed To Fetch Meeting Data 2");
    setOpenFailModal(true);
  }
};


export const setRecurrenceDayVal = (appointmentRecurrence, setMonthlyRecDayVal) => {
  if (appointmentRecurrence?.isSunday === "Y") {
    setMonthlyRecDayVal("Sunday");
  } else if (appointmentRecurrence?.isMonday === "Y") {
    setMonthlyRecDayVal("Monday");
  } else if (appointmentRecurrence?.isTuesday === "Y") {
    setMonthlyRecDayVal("Tuesday");
  } else if (appointmentRecurrence?.isWednesday === "Y") {
    setMonthlyRecDayVal("Wednesday");
  } else if (appointmentRecurrence?.isThursday === "Y") {
    setMonthlyRecDayVal("Thursday");
  } else if (appointmentRecurrence?.isFriday === "Y") {
    setMonthlyRecDayVal("Friday");
  } else if (appointmentRecurrence?.isSaturday === "Y") {
    setMonthlyRecDayVal("Saturday");
  }
};

export const handleSessionExpClose = (navigate,setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleSessionExpiration = (setSessionExpiredModal, setFailMessage, setLoading) => {
    setSessionExpiredModal(true);   // Display session expired modal
    setFailMessage("Session expired"); // Set the failure message
    setLoading(false); // Stop loading state
  };


export function handleRecDays(selectAllWeekDays, formData, setFormData) {
 
  if (selectAllWeekDays) {
    const obj = {
      isMonday: true,
      isTuesday: true,
      isWednesday: true,
      isThursday: true,
      isFriday: true,
      isSaturday: true,
      isSunday: true,
    };
    setFormData((prevState) => ({ ...prevState, recDays: { ...obj } }));
  } else {
    const allSelectedArr = Object.keys(formData?.recDays);
    let allSelected = true;
    allSelectedArr.forEach((item) => {
      if (formData?.recDays[item] === false) {
        allSelected = false;
      }
    });

    const obj = {
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      isFriday: false,
      isSaturday: false,
      isSunday: false,
    };
    setFormData((prevState) => ({ ...prevState, recDays: { ...obj } }));
  }
}


export const validateRecurrance = (
  name,
  value,
  validationType,
  dailyRecurrancePattern,
  setRecurranceErrors
) => {
  let recErrors = "";

  switch (name) {
    case "recStartTime":
      if (!value) {
        recErrors = "Start time is required.";
      }else{
        recErrors = "";
      }
      break;
    case "recEndTime":
      if (!value) {
        recErrors = "End time is required.";
      }else{
        recErrors = "";
      }
      break;
    case "recRecurrenceInterval":
      if (dailyRecurrancePattern !== "EveryWeek") {
        if (!/^(0*?[1-9][0-9]?|99)$/.test(value)) {
          recErrors = "Recurrance interval is required.";
        }else{
          recErrors = ""
        }
      }
      break;
    case "recDayOfMonth":
      if (!value || !/^(0?[1-9]|[1-2][0-9]|3[0-1])$/.test(value)) {
        recErrors = "Invalid Day of Month";
        if (validationType === "onSubmit") {
          // setFailMessage("Select valid day of month")
          // setOpenFailModal(true);
        }
      }
      break;
    case "recDays":
      const { isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday } = value;
      if (!isMonday && !isTuesday && !isWednesday && !isThursday && !isFriday && !isSaturday && !isSunday) {
        recErrors = "Select atleast one day.";
        // setFailMessage("Select atleast one day");
        // setOpenFailModal(true);
      }
      break;
  }

  setRecurranceErrors((prevErrors) => ({ ...prevErrors, [name]: recErrors }));
  return recErrors;
};



export const handleSubmit = async (e
  , formData,
  setFormErrors,
  isRecurranceSelected,
  allDaySelected,
  flow,
  Email,
  fromForEdit,
  weekGaps,
  monthNames,
  createdBy,
  createdDate,
  setLoading,
  token,
  setSuccessMessage,
  setOpenSuccessModal,
  setActive,
  setActiveMeetingsSubTab,
  setFormData,
  Currentdate,
  filteredControllRef,
  setIsRecurranceSelected,
  setFilteredControllRef,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  scrollToError
) => {
  e.preventDefault();

  const {
    staffIdFrom,
    meetingSubject,
    staffIdTo,
    staffIdOptional,
    startDate,
    endDate,
    startTime,
    endTime,
    DurationMinutes,
    isAllDay,
    timeZone,
    recRecurrenceType,
    recStartTime,
    recEndTime,
    recDurationMinutes,
    recRecurrenceInterval,
    recWeekNoId,
    recStartDate,
    recEndDate,
    recMonthOfYear,
    recDayOfMonth,
    deptTagId,
    meetingLocation,
    complianceId,
    controlRefMaster,
    meetingAgenda,
    message,
    attachmentDocuments,
    mid,
  } = formData;

  let isValidForm = true;
  const finalErrors = [];
  const meetingSubjectError = validateInput("meetingSubject", meetingSubject, setFormErrors);
  const staffIdToError = validateInput("staffIdTo", staffIdTo, setFormErrors);
  const deptTagIdError = validateInput("deptTagId", deptTagId, setFormErrors);
  const meetingLocationError = validateInput(
    "meetingLocation",
    meetingLocation, setFormErrors
  );
  const complianceIdError = validateInput("complianceId", complianceId, setFormErrors);
  const controlRefMasterError = validateInput(
    "controlRefMaster",
    controlRefMaster.filter((item) => item.isSelected),
    setFormErrors
  );
  const agendaErr = validateInput("meetingAgenda", meetingAgenda, setFormErrors)
  finalErrors.push(meetingSubjectError);
  finalErrors.push(staffIdToError);
  if (!isRecurranceSelected) {
    const startDateError = validateInput("startDate", startDate, setFormErrors);
    const endDateError = validateInput("endDate", endDate, setFormErrors);
    if (!allDaySelected) {
      const startTimeError = validateInput("startTime", startTime, setFormErrors);
      const endTimeError = validateInput("endTime", endTime, setFormErrors);
      finalErrors.push(startTimeError);
      finalErrors.push(endTimeError);
    }
    finalErrors.push(startDateError);
    finalErrors.push(endDateError);

  }
  finalErrors.push(deptTagIdError);
  finalErrors.push(meetingLocationError);
  finalErrors.push(complianceIdError);
  finalErrors.push(controlRefMasterError);
  finalErrors.push(agendaErr)

  finalErrors.forEach((err) => {
    if (err !== "") {
      isValidForm = false;
    }
  });



  if (isValidForm) {



    let emailDetail2 = {
      emailDetailId: (flow === "UpcomingMeetings" || flow === "CancelledMeetings") && fromForEdit && fromForEdit[0]?.emailDetailId ? parseInt(fromForEdit[0]?.emailDetailId) : null,
      participantEmail: (flow === "UpcomingMeetings" || flow === "CancelledMeetings") && fromForEdit && fromForEdit[0]?.participantEmail ? fromForEdit[0]?.participantEmail : Email,
      emailTypeMaster: {
        emailTypeId: 1
      },

    };






    //  New Email details  changes
    let ToObjectArr = staffIdTo?.map((item, index) => {

      return {

        emailDetailId: item?.value?.emailDetailId ? parseInt(item?.value?.emailDetailId) : null,

        participantEmail: item?.value?.participantEmail,
        emailTypeMaster: {
          emailTypeId: 2
        },

      };
    });





    let OpsObjectArr = staffIdOptional?.map((item, index) => {


      return {

        emailDetailId: item?.value?.emailDetailId ? parseInt(item?.value?.emailDetailId) : null,

        participantEmail: item?.value?.participantEmail,
        emailTypeMaster: {
          emailTypeId: 3
        },

      };


    });



    let emailDetailsArr = [emailDetail2, ...ToObjectArr, ...OpsObjectArr]





    const controllRefToSend = controlRefMaster?.filter(
      (item) => item.isSelected === true
    );

    const {
      isMonday,
      isTuesday,
      isThursday,
      isWednesday,
      isFriday,
      isSaturday,
      isSunday,
    } = formData?.recDays;


    const bodyToSend = {
      deptartmentTagMaster: {
        deptTagId: parseInt(deptTagId),
      },
      complianceTagsMaster: {
        complianceId: parseInt(complianceId),
      },
      duration: DurationMinutes,
      appointmentRecurrence: isRecurranceSelected
        ? {
          startDate: moment(recStartDate).format("YYYY-MM-DD"),
          endDate: moment(recEndDate).format("YYYY-MM-DD"),
          startTime: recStartTime?.value?.toUpperCase(),
          endTime: recEndTime?.value?.toUpperCase(),
          recurrenceType: recRecurrenceType,
          isMonday: isMonday == true ? "Y" : "N",
          isTuesday: isTuesday == true ? "Y" : "N",
          isWednesday: isWednesday == true ? "Y" : "N",
          isThursday: isThursday == true ? "Y" : "N",
          isFriday: isFriday == true ? "Y" : "N",
          isSaturday: isSaturday == true ? "Y" : "N",
          isSunday: isSunday == true ? "Y" : "N",
          recurrenceInterval: parseInt(recRecurrenceInterval),
          weekNoId: recWeekNoId ? weekGaps.indexOf(recWeekNoId) + 1 : null,
          dayOfMonth: recDayOfMonth ? parseInt(recDayOfMonth) : null,
          monthOfYear: monthNames.indexOf(recMonthOfYear) + 1,
          duration: recDurationMinutes,
        }
        : null,
      emailDetail: [...emailDetailsArr],
      attachmentDocuments: [...attachmentDocuments],
      controlRefMaster: [...controllRefToSend],
      meetingSubject: meetingSubject.substring(0, 1).toUpperCase() + meetingSubject.substring(1, meetingSubject.length),
      meetingLocation: { "locationId": parseInt(meetingLocation) },
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      startTime: startTime?.value,
      endTime: endTime?.value,
      message: message,
      isAllDay: isAllDay == true ? "Y" : "N",
      meetingAgenda: meetingAgenda,
      timeZone: timeZone,
    };







    let editBody = {
      mid: mid,
      createdBy: createdBy ? createdBy : null,
      createdDate: createdDate ? createdDate : null,
      deptartmentTagMaster: {
        deptTagId: parseInt(deptTagId),
      },
      complianceTagsMaster: {
        complianceId: parseInt(complianceId),
      },
      duration: DurationMinutes,
      appointmentRecurrence: isRecurranceSelected
        ? {
          startDate: moment(recStartDate).format("YYYY-MM-DD"),
          endDate: moment(recEndDate).format("YYYY-MM-DD"),
          startTime: recStartTime?.value?.toUpperCase(),
          endTime: recEndTime?.value?.toUpperCase(),
          recurrenceType: recRecurrenceType,
          isMonday: isMonday == true ? "Y" : "N",
          isTuesday: isTuesday == true ? "Y" : "N",
          isWednesday: isWednesday == true ? "Y" : "N",
          isThursday: isThursday == true ? "Y" : "N",
          isFriday: isFriday == true ? "Y" : "N",
          isSaturday: isSaturday == true ? "Y" : "N",
          isSunday: isSunday == true ? "Y" : "N",
          recurrenceInterval: parseInt(recRecurrenceInterval),
          weekNoId: recWeekNoId ? weekGaps.indexOf(recWeekNoId) + 1 : null,
          dayOfMonth: recDayOfMonth ? parseInt(recDayOfMonth) : null,
          monthOfYear: monthNames.indexOf(recMonthOfYear) + 1,
          duration: recDurationMinutes,
        }
        : null,
      emailDetail: [...emailDetailsArr],
      attachmentDocuments: [...attachmentDocuments],
      controlRefMaster: [...controllRefToSend],
      meetingSubject: meetingSubject.substring(0, 1).toUpperCase() + meetingSubject.substring(1, meetingSubject.length),
      meetingLocation: { "locationId": parseInt(meetingLocation) },
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      startTime: startTime?.value?.toUpperCase(),
      endTime: endTime?.value?.toUpperCase(),
      message: message,
      isAllDay: isAllDay == true ? "Y" : "N",
      meetingAgenda: meetingAgenda,
      timeZone: timeZone,
      // ...bodyToSend,
    };


    let finalBody =
      flow === "UpcomingMeetings" || flow === "CancelledMeetings"
        ? editBody
        : bodyToSend;


    try {

      let URL = flow === "UpcomingMeetings" || flow === "CancelledMeetings" ? Url.editMeeting : Url.setupMeeting
      setLoading(true);
      const setupMeetingResponse = flow === "UpcomingMeetings" || flow === "CancelledMeetings"
        ? await PUT(
          URL,
          token,
          finalBody
        )
        :
        await POST(
          URL,
          token,
          finalBody
        )

      if (setupMeetingResponse.SUCCESS) {
        // navigate('/main');
        setLoading(false);
        setSuccessMessage(setupMeetingResponse?.MESSAGE);
        setOpenSuccessModal(true);
        setActive("tab2");
        setActiveMeetingsSubTab(1);

        // resetting all states to default values -------------------------------
        setFormData({
          staffIdFrom: Email,
          meetingSubject: "",
          staffIdTo: [],
          staffIdOptional: [],
          // main fields---
          startDate: new Date(),
          endDate: new Date(),
          startTime: "",
          endTime: "",
          isAllDay: false,
          timeZone: "UTC+5:30",
          // recurring----------------------
          recStartTime: "",
          recEndTime: "",
          recStartDate: new Date(),
          recEndDate: new Date(+new Date() + 86400000),
          recRecurrenceType: "Daily",
          recRecurrenceInterval: 0,
          recDays: {
            isMonday: false,
            isTuesday: false,
            isWednesday: false,
            isThursday: false,
            isFriday: false,
            isSaturday: false,
            isSunday: false,
          },
          recWeekNoId: "",
          recDayOfMonth: "",
          recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
          // recDurationMinutes: "",
          // recDayOfWeek: "",

          // rec end------------------------------
          deptTagId: "",
          meetingLocation: "",
          complianceId: "",
          controlRefMaster: filteredControllRef.map((item) => ({
            ...item,
            isSelected: false,
          })),
          meetingAgenda: "",
          message: "",
          attachmentDocuments: [],
        });
        setIsRecurranceSelected(false);
        setFilteredControllRef((prevState) => {
          return prevState.map((item) => {
            return { ...item, isSelected: false };
          });
        });
        // resetting all states to default values -------------------------------end
      } else if (setupMeetingResponse.STATUS == 401) {
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
        setLoading(false);
      }else if (setupMeetingResponse.STATUS === 400) {
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
        setLoading(false);
      }else if (setupMeetingResponse.STATUS === 403) {
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
        setLoading(false);
      }else if (setupMeetingResponse.STATUS === 404) {
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
        setLoading(false);
      }else if (setupMeetingResponse.STATUS === 500) {
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
        setLoading(false);
      }
      else {

        setLoading(false);
        setFailMessage("Failed To Schedule Meeting");
        setOpenFailModal(true);
      }
    } catch (error) {

      setLoading(false);
      setFailMessage("Failed To Schedule Meeting 2");
      setOpenFailModal(true);
    }

  } else {
    scrollToError();
  }
};



export const handleRecurrencePattern = (appointmentRecurrence, callbacks) => {
  const {
    setDailyRecurrancePattern,
    setSelectAllWeekDays,
    setMonthlyRecurrancePattern,
    setRecurrenceDayVal,
    setMonthlyRecDayVal,
    setYearlyRecurrancePattern,
  } = callbacks;

  switch (appointmentRecurrence?.recurrenceType) {
    case "Daily":
      if (appointmentRecurrence?.recurrenceInterval === 1) {
        setDailyRecurrancePattern("EveryDay");
      } else if (appointmentRecurrence?.recurrenceInterval === 0) {
        setDailyRecurrancePattern("EveryWeek");
      }
      return "Daily";

    case "Weekly":
      if (
        appointmentRecurrence?.isMonday === "Y" &&
        appointmentRecurrence?.isTuesday === "Y" &&
        appointmentRecurrence?.isWednesday === "Y" &&
        appointmentRecurrence?.isThursday === "Y" &&
        appointmentRecurrence?.isFriday === "Y" &&
        appointmentRecurrence?.isSaturday === "Y" &&
        appointmentRecurrence?.isSunday === "Y"
      ) {
        setSelectAllWeekDays(true);
      }
      return "Weekly";

    case "Monthly":
      if (!appointmentRecurrence?.weekNoId) {
        setMonthlyRecurrancePattern("EveryDay");
      } else {
        setMonthlyRecurrancePattern("EveryWeekDay");
        setRecurrenceDayVal(appointmentRecurrence, setMonthlyRecDayVal);
      }
      return "Monthly";

    case "Yearly":
      if (appointmentRecurrence?.dayOfMonth) {
        setYearlyRecurrancePattern("YearFirstTab");
      } else {
        setYearlyRecurrancePattern("YearSecondTab");
        setRecurrenceDayVal(appointmentRecurrence, setMonthlyRecDayVal);
      }
      return "Yearly";

    default:
      return null;
  }
};

export const handleTimeChangeLogic = (
  e,
  value,
  TimeArray,
  formData,
  setFormData,
  handleFormChange,
  calculateTimeDifferenceOuter,
  formatTime2,
  isStartTimeGreaterThanEndTime,
  addOneDay
) => {
  // Find the index of the selected start time
  const startTimeIndex = TimeArray.indexOf(value);

  // Determine the end time
  const endTime =
    startTimeIndex === TimeArray.length - 1
      ? {
        label: TimeArray[0],
        value: TimeArray[0],
        isDisabled: false,
      }
      : {
        label: TimeArray[startTimeIndex + 1],
        value: TimeArray[startTimeIndex + 1],
        isDisabled: false,
      };

  // Update the form data with the new end time
  setFormData({
    ...formData,
    endTime: endTime,
  });

  // Update the start time in the form data
  handleFormChange("startTime", e);

  // Calculate the time difference
  const endTimeValue =
    startTimeIndex === TimeArray.length - 1
      ? TimeArray[0]
      : TimeArray[startTimeIndex + 1];

  calculateTimeDifferenceOuter(
    value,
    endTimeValue,
    formData,
    setFormData,
    formatTime2,
    isStartTimeGreaterThanEndTime,
    addOneDay
  );
};


export const handleAllDayToggle = (
  isAllDay,
  nearestTime,
  TimeArray,
  setFormData,
  handleFormChange,
  formData
) => {
  const ntime = nearestTime();

  if (!isAllDay) {
    setFormData((prevState) => ({
      ...prevState,
      startTime: { label: "12:00 AM", value: "12:00 AM" },
      endTime: { label: "12:00 AM", value: "12:00 AM" },
      recStartTime: { label: "12:00 AM", value: "12:00 AM" },
      recEndTime: { label: "12:00 AM", value: "12:00 AM" },
      recDurationMinutes: "24h : 00m",
    }));
  } else {
    const nextTimeIndex = TimeArray.indexOf(ntime) + 1;
    const nextTime =
      nextTimeIndex === TimeArray.length ? TimeArray[0] : TimeArray[nextTimeIndex];

    setFormData((prevState) => ({
      ...prevState,
      startTime: { label: ntime, value: ntime },
      endTime: { label: nextTime, value: nextTime },
      recDurationMinutes: "00h : 30m",
      recStartTime: { label: ntime, value: ntime },
      recEndTime: { label: nextTime, value: nextTime },
      DurationMinutes: "00h : 30m",
    }));
  }

  handleFormChange("isAllDay", !isAllDay);
};



const SetUpMeeting = () => {

  const mdata = useLocation();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("TOKEN");
  let Email = Cuurent_EMAIL();
  let USERNAME = Cuurent_USERNAME();
  const newRef = useRef(null)
  const newRef2 = useRef(null)
  const RecRef = useRef(null)
  const RecRef2 = useRef(null)
  const [emails, setEmails] = useState([]);
  const [inputVal, setInputVal] = useState("");
  const [inputValOpt, setInputValOpt] = useState("");
  // modal states--------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [RcurDropdownOpen, setRcurDropdownOpen] = useState(false);
  const [RcurDropdownOpen2, setRcurDropdownOpen2] = useState(false);

  const crefContainerRef = useRef(null);



  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
    setDropdownOpen2(false);
  };

  const customSelectStyles = {
    ...customStyles,
    control: (provided, state) => ({
      ...provided,
      border: 'none',
      minHeight: '32px',
      borderRadius: '5px',
      height: '15px',
      fontSize: '13px',
      marginLeft: '-6px',
      color: 'black',
      width: '106px',
      boxShadow: state.isFocused ? 'none' : state.isHovered ? '0 0 0 2px #00aff1' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? '#00aff1' : '#ccc'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      fontSize: '12px',
      '&:hover': {
        backgroundColor: '#00000029',
        color: 'white'
      }
    }),
    menu: (provided) => ({
      ...provided,
      width: '150px',
      maxHeight: '200px',
      zIndex: 9999
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '125px',
      overflowY: 'auto'
    })
  };


  const handleDropdownToggle2 = () => {
    setDropdownOpen2(!dropdownOpen2);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClick = (event) => {
      handleClickOutside(event, newRef, newRef2, setDropdownOpen, setDropdownOpen2);
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [newRef, newRef2]);

  useEffect(() => {
    const handleClick = (event) => {
      handleClickOutside2(event, RecRef, RecRef2, setRcurDropdownOpen, setRcurDropdownOpen2);
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [RecRef, RecRef2]);


  let meetingId, flow;

  if (mdata.state) {
    meetingId = mdata?.state?.meetingId;
    flow = mdata?.state?.flow;
  }


  // ----------------------------------------------------------------------------- User Refs---------------------------------------------------------------------------------
  const toRef = useRef();
  const optRef = useRef();

  // ------------------------------------------------------------------------------Data States-------------------------------------------------------------------------------
  const { setActive, setLoading, setActiveMeetingsSubTab } =
    useContext(contextData);

  // recurring
  const [TimeArray, setTimeArray] = useState([
    "12:00 AM",
    "12:30 AM",
    "01:00 AM",
    "01:30 AM",
    "02:00 AM",
    "02:30 AM",
    "03:00 AM",
    "03:30 AM",
    "04:00 AM",
    "04:30 AM",
    "05:00 AM",
    "05:30 AM",
    "06:00 AM",
    "06:30 AM",
    "07:00 AM",
    "07:30 AM",
    "08:00 AM",
    "08:30 AM",
    "09:00 AM",
    "09:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "01:00 PM",
    "01:30 PM",
    "02:00 PM",
    "02:30 PM",
    "03:00 PM",
    "03:30 PM",
    "04:00 PM",
    "04:30 PM",
    "05:00 PM",
    "05:30 PM",
    "06:00 PM",
    "06:30 PM",
    "07:00 PM",
    "07:30 PM",
    "08:00 PM",
    "08:30 PM",
    "09:00 PM",
    "09:30 PM",
    "10:00 PM",
    "10:30 PM",
    "11:00 PM",
    "11:30 PM",
  ]);


  const [recurringDurations, setRecurringDurations] = useState([
    "30 Minutes",
    "1 Hour",
    "2 Hour",
    "3 Hour",
    "4 Hour",
    "5 Hour",
  ]);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const Currentdate = new Date();

  const [dailyRecurrancePattern, setDailyRecurrancePattern] =
    useState("EveryDay");
  const [monthlyRecurrancePattern, setMonthlyRecurrancePattern] =
    useState("EveryDay");
  const [yearlyRecurrancePattern, setYearlyRecurrancePattern] =
    useState("YearFirstTab");

  const [weeklyRecurrancePattern, setWeeklyRecurrancePattern] = useState("");
  const [recurranceEveryDayNum, setRecurranceEveryDayNum] = useState("");
  const [recurranceEveryWeekNum, setRecurranceEveryWeekNum] = useState("");
  const [recurranceWeekDays, setRecurrenceWeekDays] = useState([""]);
  const [recurranceStartDate, setRecurranceStartDate] = useState("");
  const [recurranceEndDate, setRecurranceEndDate] = useState("");
  const [controllFilterInp, setControllFilterInp] = useState("");

  const [monthlyRecDayVal, setMonthlyRecDayVal] = useState("");

  // ------------------------------------------------------------------------------------Data States---------------------------------------------------------------------------
  const [departmentTags, setDepartmentTags] = useState([]);
  const [locations, setLocations] = useState([]);
  const [complianceTags, setComplianceTags] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [filteredToEmployeeData, setFilteredToEmployeeData] = useState([]);
  const [filteredOptionalEmployeeData, setFilteredOptionalEmployeeData] =
    useState([]);
  const [filteredControllRef, setFilteredControllRef] = useState([]);
  const [files, setFiles] = useState([]);
  const [actualData, setActualData] = useState([]);

  const [indexOfStartTime, setIndexOfStartTime] = useState(-1);
  const [indexOfStartTimeOuter, setIndexOfStartTimeOuter] = useState(-1);

  const [openControlRefDropDown, setOpenControlRefDropDown] = useState(false);

  const [fromForEdit, setFromForEdit] = useState();

  const [recPatternString, setRecPatternString] = useState("")

  const [emailDetailId, setEmailDetailId] = useState();
  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");

  const [teams, setTeams] = useState([]);

  const [teamsCopy, setTeamsCopy] = useState([]);
  const [selectByTeam, setSelectByTeam] = useState(false);

  const nt = nearestTime()

  const [formData, setFormData] = useState({
    staffIdFrom: USERNAME,
    meetingSubject: "",
    staffIdTo: [],
    staffIdOptional: [],
    // main fields---
    startDate: new Date(),
    endDate: new Date(),
    startTime: {
      label: nt,
      value: nt
    },
    endTime: {
      label: TimeArray.indexOf(nt) + 1 == TimeArray.length ? TimeArray[0] : TimeArray[TimeArray.indexOf(nt) + 1],
      value: TimeArray.indexOf(nt) + 1 == TimeArray.length ? TimeArray[0] : TimeArray[TimeArray.indexOf(nt) + 1]
    },
    isAllDay: false,
    timeZone: "UTC+5:30",
    // recurring----------------------
    recStartTime: "",
    recEndTime: "",
    recStartDate: new Date(),
    recEndDate: new Date(+new Date() + 86400000),
    recRecurrenceType: "Daily",
    recRecurrenceInterval: 0,
    recDays: {
      isMonday: false,
      isTuesday: false,
      isWednesday: false,
      isThursday: false,
      isFriday: false,
      isSaturday: false,
      isSunday: false,
    },
    recWeekNoId: "",
    recDayOfMonth: "",
    recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
    recDurationMinutes: "00h : 00m",
    DurationMinutes: "00h : 30m",
    // recDayOfWeek: "",

    // rec end------------------------------
    deptTagId: "",
    meetingLocation: "",
    complianceId: "",
    controlRefMaster: [],
    meetingAgenda: "",
    message: "",
    attachmentDocuments: [],
  });


  const [formErrors, setFormErrors] = useState({
    meetingSubject: "",
    staffIdTo: "",
    // main fields---
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    deptTagId: "",
    meetingLocation: "",
    complianceId: "",
    controlRefMaster: "",
    meetingAgenda: "",
    message: ""
  });


  const [recRememberValues, setRememberValues] = useState({})


  const [recurranceErrors, setRecurranceErrors] = useState({
    recStartTime: "",
    recEndTime: "",
    recStartDate: "",
    recEndDate: "",
    recRecurrenceType: "",
    recRecurrenceInterval: "",
    recDays: "",
    recWeekNoId: "",
    recDayOfMonth: "",
    recMonthOfYear: "",
    recDurationMinutes: "",
    DurationMinutes: "",
  })
  // useEffect(() => {

  // }, [formData]);
  // useEffect(() => {

  // }, [formErrors]);
  // useEffect(() => {

  // }, [filteredControllRef]);

  // ----------------------------------------------------------------------------------Custom Styles----------------------------------------------------------------------------
  const modalCss = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "70%",
      padding: 15,
      marginTop: "20px",
    },
  };
  // const recurringDatePickerStyle = {
  //   control: (base, state) => ({
  //     ...base,
  //     border: "1px solid #ccc", // Example: Add a border
  //     borderRadius: "5px",
  //     height: "15px",
  //     width: "100%", // Example: Add rounded corners
  //   }),
  // };

  const module = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ]
  };


  // --------------------------------------------------------------------------------Boolean States--------------------------------------------------------------------------
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isControlRefOpened, setControllRefOpened] = useState(false);
  const [recurringPop, setRecurringPop] = useState(false);
  const [focused, setFocused] = useState(false);
  const [openToUserList, setOpenToUserList] = useState(false);
  const [openOptionalUserList, setOpenOptionalUserList] = useState(false);
  const [recurranceStartDatePicker, setOpenRecurranceStartDatePicker] =
    useState(false);
  const [recurranceEndDatePicker, setOpenRecurranceEndDatePicker] =
    useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectAllWeekDays, setSelectAllWeekDays] = useState(false);
  const [isRecurranceSelected, setIsRecurranceSelected] = useState(false);
  const [disableRec, setDisableRec] = useState(false);
  const [allDaySelected, setAllDaySelected] = useState(false);

  const [isToFieldClicked, setToFieldIsClicked] = useState(false);
  const [isOptionalFieldClicked, setOptionalFieldClicked] = useState(false);

  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  
  // --------------------------------------------------------------------------------Variables--------------------------------------------------------------------------------

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weekGaps = ["First", "Second", "Third", "Fourth", "Fifth"];


  // useEffect(() => {

  // }, [teams])



  useEffect(() => {
    fetchAllDropDownData({
      setLoading,
      setDepartmentTags,
      setComplianceTags,
      setFormData,
      setTeams,
      setTeamsCopy,
      setLocations,
      setEmployeeData,
      setFilteredControllRef,
      setFilteredToEmployeeData,
      setFilteredOptionalEmployeeData,
      getMeetingDataById,
      setDisableRec,
      setSessionExpiredModal,
      setFailMessage,
      flow,
      token,
      Url,
      Email,
      formData,
      setFromForEdit,
      setEmailDetailId,
      setCreatedBy,
      setCreatedDate,
      setAllDaySelected,
      setActualData,
      setMonthlyRecDayVal,
      setDailyRecurrancePattern,
      setSelectAllWeekDays,
      setMonthlyRecurrancePattern,
      setYearlyRecurrancePattern,
      setRecPatternString,
      setRememberValues,
      monthNames,
      Currentdate,
      meetingId,
      GET,
      USERNAME,
      getEmailClassification,
      setOpenFailModal
    });
  }, []);


  // useEffect(() => {

  // }, [filteredToEmployeeData]);


  useEffect(() => {
    const handleClick = handleOutsideClick(crefContainerRef, setOpenControlRefDropDown);
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, [crefContainerRef, setOpenControlRefDropDown]);

  const inner = document.getElementById("custom-reference-modal");

  inner?.parentElement?.classList?.add("custom-reference-modal-main");

  useEffect(() => {
    setTimeout(() => {
      const inner = document.getElementById("custom-reference-modal");

      inner?.parentElement?.classList?.add("custom-reference-modal-main");
    }, 200);
  }, [modalIsOpen]);






  useEffect(() => {
    if (recurringPop) {
      calculateTimeDifferenceInner(formData?.recStartTime?.value, formData?.recEndTime?.value,
        formData,
        setFormData,
        formatTime2,
        isStartTimeGreaterThanEndTime,
        addOneDay
      )
    }
  }, [formData.recEndDate, formData?.recStartDate])
  useEffect(() => {
    if (recurringPop) {
      calculateTimeDifferenceInner(formData?.startTime?.value, formData?.endTime?.value,
        formData,
        setFormData,
        formatTime2,
        isStartTimeGreaterThanEndTime,
        addOneDay
      )
    }
  }, [formData.endDate, formData?.startDate])




  // function addOneDay(inputDate) {
  //   // Parse the input date with the specified format
  //   const formattedDate = moment(inputDate, 'DD-MM-YYYY');
  //   // Add one day
  //   const newDate = formattedDate.add(1, 'days');
  //   // Format the new date as per the original format
  //   const result = newDate.format('YYYY-MM-DD');
  //   return new Date(result);
  // }

  // const formatTime2 = (minutes) => {
  //   let hours = Math.floor(minutes / 60);
  //   if (hours >= 24) {
  //     hours = hours % 24
  //   }
  //   const remainingMinutes = minutes % 60;
  //   return `${String(hours).padStart(2, '0')}h:${String(remainingMinutes).padStart(2, '0')}m`;
  // };

  function isStartTimeGreaterThanEndTime(startTime, endTime) {
    const startDateTime = moment(startTime, 'hh:mm A');
    const endDateTime = moment(endTime, 'hh:mm A');

    let result = startDateTime.isSameOrAfter(endDateTime);
    return result;
  }



  // const addMoreHalfHours = (inputTime) => {
  //   const format = 'hh:mm A';

  //   // Parse the input time using moment
  //   const parsedTime = moment(inputTime, format);

  //   // Add 2 half-hours to the parsed time (adjust the number as needed)
  //   const resultTime = parsedTime.add(1 * 30, 'minutes');

  //   // Format and return the result
  //   return resultTime.format(format);
  // };





  // function closeModal() {
  //   setIsOpen(false);
  // }


  // -----------------------------------------------------------------------------------------Controll Ref Functions----------------------------------------------------------------



  // const handleSelectAll = () => {
  //   setSelectAllChecked(!selectAllChecked);
  // };

  const optionsStart = TimeArray.map((item, index) => ({
    label: item,
    value: item,
    isDisabled: false
  }));
  const [startTimeArr, setStartTimeArr] = useState([...optionsStart])

  const optionsEnd = TimeArray.map((item, index) => ({
    label: item,
    value: item,
    // isDisabled: index <= indexOfStartTimeOuter
    isDisabled: ((moment(formData.startDate).format("DD-MM-YYYY") == moment(formData.endDate).format("DD-MM-YYYY")) && isStartTimeGreaterThanEndTime(formData.startTime?.value, item))

  }));


  const optionsStartRecurrance = TimeArray.map((item, index) => ({
    label: item,
    value: item,
    isDisabled: false
  }));
  const optionsEndRecurrance = TimeArray.map((item, index) => ({
    label: item,
    value: item,
    // isDisabled: index <= indexOfStartTime
    isDisabled: ((moment(formData.recStartDate).format("DD-MM-YYYY") == moment(formData.recEndDate).format("DD-MM-YYYY")) && isStartTimeGreaterThanEndTime(formData.recStartTime?.value, item))

  }));


  useEffect(() => {
    setControllRefOpened(true);
    handleFormChange("selectAllControllRef");
  }, [selectAllChecked]);

  // ------------------------------------------------------------------------------------   recurrance Functionallity --------------------------------------------------
  useEffect(() => {
    handleRecDays(selectAllWeekDays, formData, setFormData);
  }, [selectAllWeekDays]);

  // ------------------------------Controll Ref Search---------------------------


  const handleCloseControllRefDropdown = () => {
    setControllFilterInp("");
    const Tofiltered = [...formData.controlRefMaster];
    setFilteredControllRef(Tofiltered);
    setOpenControlRefDropDown(false);
  }




  const handlerecurranceCloseOk = () => {
    setRecurringPop(false);

    setRecurranceErrors({
      recStartTime: "",
      recEndTime: "",
      recStartDate: "",
      recEndDate: "",
      recRecurrenceType: "",
      recRecurrenceInterval: "",
      recDays: "",
      recWeekNoId: "",
      recDayOfMonth: "",
      recMonthOfYear: "",
      recDurationMinutes: "",
      DurationMinutes: "",
    })

  };

  const handleRemoveRecurrence = (recurranceTime) => {
    setRecPatternString("");
    setFormData((prevState) => ({
      ...prevState,
      // recurring----------------------
      recStartTime: formData.isAllDay ? { label: "12:00 AM", value: "12:00 AM" } : "",
      recEndTime: formData.isAllDay ? { label: "12:00 AM", value: "12:00 AM" } : "",
      recStartDate: new Date(),
      recEndDate: new Date(+new Date() + 86400000),
      recRecurrenceType: "Daily",
      recRecurrenceInterval: 0,
      recDays: {
        isMonday: false,
        isTuesday: false,
        isWednesday: false,
        isThursday: false,
        isFriday: false,
        isSaturday: false,
        isSunday: false,
      },
      recWeekNoId: "",
      recDayOfMonth: "",
      recDurationMinutes: formData.isAllDay ? "24h : 00m" : "00h : 00m",
      recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
    }));

    setIsRecurranceSelected(false);
    setRememberValues({});
    setRecurringPop(false);
    setRecurranceErrors({
      recStartTime: "",
      recEndTime: "",
      recStartDate: "",
      recEndDate: "",
      recRecurrenceType: "",
      recRecurrenceInterval: "",
      recDays: "",
      recWeekNoId: "",
      recDayOfMonth: "",
      recMonthOfYear: "",
      recDurationMinutes: "",
      DurationMinutes: "",
    })

  };


  const handleDepartTag = () => {
    setRecurringPop(false)
    // setOpenControlRefDropDown(false)
    handleCloseControllRefDropdown()
  }
  // --------------------------------------------------------------------------------------Handlee Form change================================================

  const handleFormChange = (fieldName, e) => {
    let name, fieldValue;
   
    if (e?.target) {
      name = e.target.name;
      fieldValue = e.target.value;
    } else {
      name = fieldName;
      fieldValue = e;
    }
    console.log(" -----------------------------------name, fieldValue", name, fieldValue)

    if (name === "staffIdTo") {
      
      const removeDuplicates = (data) => {
        let emails = [];
        let noDup = [];
        data?.map((i) => {
          if (!emails.includes(i?.value?.participantEmail)) {
            emails.push(i?.value?.participantEmail)
            noDup.push(i)
          }
        })
        let optEmails = formData?.staffIdOptional.map((k) => {
          return k?.value?.participantEmail
        })
        let removeOpt = noDup?.filter((i) => !optEmails.includes(i?.value?.participantEmail))
        return removeOpt
      }

      let dataToSet = [];
      let addedTeams =[]
      fieldValue?.map((i, index) => {
        if (i?.isTeam) {
          addedTeams.push(i?.label);
          i.value.map((j) => {
            dataToSet.push({
              label: j?.fullName, value: {
                emailDetailId: null,
                participantEmail: j?.emailId,
                emailTypeMaster: {
                  emailTypeId: 2
                },
              }
            })
          });

          let teamsDataset = teams?.filter((k) => {
            return !addedTeams?.includes(k?.label)
          })
          setTeams(teamsDataset);
        }
        else {
          // debugger
          dataToSet.push({
            label: i?.label, value: {
              emailDetailId: i?.value?.emailDetailId ? i?.value?.emailDetailId : null,
              participantEmail: i?.value?.participantEmail,
              emailTypeMaster: {
                emailTypeId: 2
              }
            }
          })
        }
      })
      
      let noDuplicates = removeDuplicates(dataToSet)
      const loggedInUserEmail = Email;
      let noDuplicateswithoutFrom = noDuplicates.filter((i) => {
        if (loggedInUserEmail != i?.value?.participantEmail) {
          return i
        }
      })

      setFormData((prevState) => {
        return {
          ...prevState,
          ["staffIdTo"]: [...noDuplicateswithoutFrom],
        };
      });

      let emps = []
      fieldValue.map((i) => {
        if (i?.isTeam) {
          i?.value?.map((j) => {
            emps.push(j?.emailId);
            return null;
          });
        }
        else {
          emps.push(i?.value?.participantEmail)
        }
      })
      formData?.staffIdOptional?.forEach((i) => {
        emps.push(i?.value?.participantEmail);
      });
      let empList = filteredOptionalEmployeeData?.filter((i) => {
        return !emps?.includes(i?.value?.participantEmail)
      })
      setFilteredToEmployeeData(empList);
      
    } else if (name == "meetingSubject") {
      const formattedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
      setFormData((prevState) => {
        return {
          ...prevState,
          "meetingSubject": formattedValue,
        };
      });

    } else if (name == "staffIdOptional") {

      let opsarr = []
      opsarr = fieldValue?.map((i) => {
        return ({
          ...i, emailTypeMaster:
            { emailTypeId: 3 }
        })
      });

      setFormData((prevState) => {
        return {
          ...prevState,
          ["staffIdOptional"]: [...fieldValue],
        };
      });



      let emps = []

      fieldValue.map((i) => {
        emps?.push(i?.value?.participantEmail);
        return null;
      });

      formData?.staffIdTo?.map((i) => {
        emps.push(i?.value?.participantEmail);
        return null;
      });


      let empList = filteredOptionalEmployeeData?.filter((i) => {
        return !emps?.includes(i?.value?.participantEmail)
      })

      setFilteredToEmployeeData(empList);

    } else if (name == "selectAllControllRef") {
      if (selectAllChecked) {
        setFormData((prevState) => {
          return {
            ...prevState,
            controlRefMaster: prevState.controlRefMaster?.map((item) => {
              return { ...item, isSelected: true };
            }),
          };
        });
        setFilteredControllRef((prevState) => {
          return prevState?.map((item) => {
            return { ...item, isSelected: true };
          });
        });
      } else {
        setFormData((prevState) => {
          return {
            ...prevState,
            controlRefMaster: prevState.controlRefMaster?.map((item) => {
              return { ...item, isSelected: false };
            }),
          };
        });
        setFilteredControllRef((prevState) => {
          return prevState?.map((item) => {
            return { ...item, isSelected: false };
          });
        });
      }
    } else if (name == "controlRefMaster") {
      setFormData((prevState) => {
        return {
          ...prevState,
          controlRefMaster: prevState.controlRefMaster?.map((item) => {
            return item.controlRefId == fieldValue
              ? { ...item, isSelected: !item.isSelected }
              : item;
          }),
        };
      });
      setFilteredControllRef((prevState) => {
        return prevState?.map((item) => {
          return item.controlRefId == fieldValue
            ? { ...item, isSelected: !item.isSelected }
            : item;
        });
      });
    } else if (name == "attachmentDocuments") {

      setFormData((prevState) => {
        return {
          ...prevState,
          attachmentDocuments: [...prevState.attachmentDocuments, ...fieldValue],
        };
      });
    } else if (name == "recRecurrenceType") {
      setDailyRecurrancePattern("EveryDay");
      setFormData((prevState) => ({
        ...prevState,
        // recStartTime: "",
        // recEndTime: "",
        recStartDate: prevState.recStartDate,
        recEndDate: prevState.recEndDate,
        recRecurrenceType: fieldValue,
        recRecurrenceInterval: 0,
        recDays: {
          isMonday: false,
          isTuesday: false,
          isWednesday: false,
          isThursday: false,
          isFriday: false,
          isSaturday: false,
          isSunday: false,
        },
        recWeekNoId: "",
        recDayOfMonth: "",
        recMonthOfYear: `${monthNames[Currentdate.getMonth()]}`,
      }));

      setRecurranceErrors({
        recStartTime: "",
        recEndTime: "",
        recStartDate: "",
        recEndDate: "",
        recRecurrenceType: "",
        recRecurrenceInterval: "",
        recDays: "",
        recWeekNoId: "",
        recDayOfMonth: "",
        recMonthOfYear: "",
        recDurationMinutes: "",
        DurationMinutes: "",
      })

      setMonthlyRecDayVal("");
    } else if (name == "MonthlyRecDayChange") {
      const obj = {
        isMonday: false,
        isTuesday: false,
        isWednesday: false,
        isThursday: false,
        isFriday: false,
        isSaturday: false,
        isSunday: false,
      };
      let newObj = { ...obj, [`is${fieldValue}`]: true };
      setFormData((prevState) => {
        return { ...prevState, recDays: newObj };
      });
    } else if (
      name == "isMonday" ||
      name == "isTuesday" ||
      name == "isWednesday" ||
      name == "isThursday" ||
      name == "isFriday" ||
      name == "isSaturday" ||
      name == "isSunday"
    ) {
      let obj = formData?.recDays;
      let newObj = { ...obj, [name]: !obj[name] };
      validateRecurrance("recDays", newObj, "onSubmit", dailyRecurrancePattern, setRecurranceErrors)
      setFormData((PrevState) => ({ ...PrevState, recDays: { ...newObj } }));
    } else if (name == "EmailOptionalAdd") {
      // alert("innnnn")
      if (fieldValue == "Enter") {
        // if (
        //   /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(inputValOpt)
        // ) {
        //   setFormData((prevState) => {
        //     return {
        //       ...prevState,
        //       staffIdOptional: [...prevState.staffIdOptional, inputValOpt],
        //     };
        //   });
        //   setInputValOpt("");
        // }
      }
    } else if (name == "EmailOptionalRemove") {
      let emails = formData?.staffIdOptional?.filter((i, index) => {
        return index != fieldValue;
      });
      setFormData((prevState) => {
        return { ...prevState, staffIdOptional: [...emails] };
      });
    } else if (name == "EmailToAdd") {
      // alert("innnnn")
      if (fieldValue == "Enter") {
        // if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(inputVal)) {
        //   setFormData((prevState) => {
        //     return {
        //       ...prevState,
        //       staffIdTo: [...prevState.staffIdTo, inputVal],
        //     };
        //   });
        //   setInputVal("");
        // }
      }
    } else if (name == "EmailToRemove") {

      let emails = formData?.staffIdTo?.filter((i, index) => {
        return index != fieldValue;
      });
      setFormData((prevState) => {
        return { ...prevState, staffIdTo: [...emails] };
      });
    } else if (name == "isAllDay") {
      setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      setAllDaySelected(fieldValue);
      setFormErrors((prevErrors) => ({ ...prevErrors, startTime: "", endTime: "" }))
    }
    else if (name == "recRecurrenceInterval") {
      setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      validateRecurrance(name, fieldValue, "onSubmit", dailyRecurrancePattern, setRecurranceErrors)
    }
    else if (name == "recStartTime" || name == "recEndTime") {
      setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      validateRecurrance(name, fieldValue, "onSubmit", dailyRecurrancePattern, setRecurranceErrors)
    }
    else if (name == "recDayOfMonth") {
      setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      validateRecurrance(name, fieldValue, "onSubmit", dailyRecurrancePattern, setRecurranceErrors)
    }
    else if (name == "endDate") {
      let startD = moment(formData.startDate).format("DD-MM-YYYY");
      let endD = moment(fieldValue).format("DD-MM-YYYY")
      let startT = formData.startTime?.value;
      let endT = formData.endTime?.value;
      if ((moment(formData.startDate).format("DD-MM-YYYY") == moment(fieldValue).format("DD-MM-YYYY")) && isStartTimeGreaterThanEndTime(formData.startTime?.value, formData.endTime?.value)) {
        setFailMessage("The end date you entered occurs before the start date.")
        setOpenFailModal(true)
      }
      else {
        setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      }
    }
    else if (name == "recEndDate") {
      let startD = moment(formData.recStartDate).format("DD-MM-YYYY");
      let endD = moment(fieldValue).format("DD-MM-YYYY")
      let startT = formData.recStartTime?.value;
      let endT = formData.recEndTime?.value;
      if ((moment(formData.recStartDate).format("DD-MM-YYYY") == moment(fieldValue).format("DD-MM-YYYY")) && isStartTimeGreaterThanEndTime(formData.recStartTime?.value, formData.recEndTime?.value)) {
        setFailMessage("The end date you entered occurs before the start date.")
        setOpenFailModal(true)
      }
      else {
        setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
      }
    }
    else {
      setFormData((prevState) => ({ ...prevState, [name]: fieldValue }));
    }

    //------------------------------------------------------- validate - input - call---------------------------------------------------------
    if (name == "staffIdTo") {
      validateInput("staffIdTo", [...formData.staffIdTo, `${fieldValue}`], setFormErrors);
    } else if (name == "EmailToRemove") {
      let removed = formData?.staffIdTo?.filter(
        (item, index) => index != fieldValue
      );
      validateInput("staffIdTo", removed, setFormErrors);
    } else if (name == "controlRefMaster" && isControlRefOpened) {
      const changed = formData.controlRefMaster?.map((item) => {
        return item.controlRefId == fieldValue
          ? { ...item, isSelected: !item.isSelected }
          : item;
      });
      const selected = changed.filter((item) => item.isSelected);
      validateInput("controlRefMaster", selected, setFormErrors);
    } else if (name == "selectAllControllRef" && isControlRefOpened) {
      const changed = formData.controlRefMaster?.map((item) => {
        return { ...item, isSelected: !item.isSelected };
      });
      validateInput(
        "controlRefMaster",
        changed.filter((item) => item.isSelected),
        setFormErrors
      );

    } else if (name == "startTime") {
      validateInput("startTime", fieldValue, setFormErrors)
      validateInput("endTime", fieldValue, setFormErrors)
    }
    else {

      validateInput(name, fieldValue, setFormErrors);
    }
  };





  // -------------------------------------------------------------------------------- Handle Errors Validation ----------------------------------------------------------------------------------------
  //------------------------------------------------------------------------------------------ handle Form Value Change------------------------------------------------------------------------------------




  // -------------------------------------------------------------------------------------Handle Scroll If Errors------------------------------------------------------------------
  const scrollToError = () => {
    // Find the first element with the "error" class and scroll to it
    const firstError = document.querySelector(".form-error");
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth" });
    }
  };

  // function to handleNavigate after submit
  // const navigateAfterSubmit = () => {
  //   navigate("/main/meetings/my-meetings");
  // };
  // -------------------------------------------------------------------------------------Handle Submit Form----------------------------------------------------------------------

  // const handleCloseFailModel = () => {
  //   setOpenFailModal(false);
  //   setFailMessage("");
  // };



  return (
    <form
      className="meeting_container"
      onSubmit={(e) => handleSubmit(e
        , formData,
        setFormErrors,
        isRecurranceSelected,
        allDaySelected,
        flow,
        Email,
        fromForEdit,
        weekGaps,
        monthNames,
        createdBy,
        createdDate,
        setLoading,
        token,
        setSuccessMessage,
        setOpenSuccessModal,
        setActive,
        setActiveMeetingsSubTab,
        setFormData,
        Currentdate,
        filteredControllRef,
        setIsRecurranceSelected,
        setFilteredControllRef,
        setSessionExpiredModal,
        setFailMessage,
        setOpenFailModal,
        scrollToError
      )}
      data-testid="handleSubmit"
      onKeyDown={handleFormKeyDown}
    >
      <div className="form-container">
        <h4
          className="setup-meeting-title field-label"
          style={{ visibility: modalIsOpen == false ? "visible" : "hidden", fontSize: "17px", width: "98%" }}
        >
          Setup Meeting
        </h4>
        <div className="form_top">
          <div className="form-top-left">
            <div className="form-top-left-row">
              <label for="" className="field-label">
                From:
              </label>
              <input
                className="form-top-input"
                type=""
                name="staffIdFrom"
                readOnly={true}
                value={formData?.staffIdFrom}
              />
            </div>
            <div className="form-top-left-row" data-testid="meetingSubjectDropdown" onClick={() => handleCloseControllRefDropdown()}>
              <label for="" className="field-label">
                Meeting Subject<span style={{ color: "red" }}>*</span>:
              </label>
              <div style={{ width: "100%" }}>
                <input
                  className="form-top-input"
                  type="text"
                  data-testid="meetingSubject"
                  name="meetingSubject"
                  value={formData.meetingSubject}
                  onChange={(e) => handleFormChange("meetingSubject", e)}

                />
                {formErrors?.meetingSubject && (
                  <div
                    style={{ width: "100%", textAlign: "left" }}
                    className="form-error"
                  >
                    {formErrors?.meetingSubject}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="form-top-right">
            <button className="send_btn" data-testid="formSubmit" type="submit" style={{ height: "78px", marginTop: formErrors.meetingSubject ? "13px" : "0" }}>
              <div>Send </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="73.015"
                height="52.015px"
                viewBox="0 0 73.015 72.429"
              >
                <g
                  id="Icon_feather-send"
                  data-name="Icon feather-send"
                  transform="translate(36.214 -2.828) rotate(45)"
                >
                  <path
                    id="Path_152274"
                    data-name="Path 152274"
                    d="M43.568,3,16.5,30.068"
                    transform="translate(8.647 0)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    id="Path_152275"
                    data-name="Path 152275"
                    d="M52.215,3,34.99,52.215,25.147,30.068,3,20.225Z"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div className="meeting-name-container " data-testid="filteredToEmployeeDataDropdown" onClick={() => { handleCloseControllRefDropdown() }}>
          <label for="" className="field-label">
            To<span style={{ color: "red" }}>*</span>:
          </label>
          <div
            className="meeting-name-inp to-relative"
            style={{ paddingLeft: "2px", display: "grid", gridTemplateColumns: "86% 14%" }}
          >
            <Select
              className="multiselect_email"
              isMulti={true}
              placeholder="Select"
              value={formData?.staffIdTo}
              styles={customStylesMulti}
              onChange={(item) => handleFormChange("staffIdTo", item)}

              // options={filteredToEmployeeData}
              options={selectByTeam ? teams : filteredToEmployeeData}
              inputValue={inputVal}
              onInputChange={(val) => { setInputVal(val) }}
              menuIsOpen={inputVal.length >= 3 ? true : false}
              data-testid="filteredToEmployeeData"
            />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div
                style={{ padding: '4px 8px', fontSize: "14px", color: selectByTeam ? '#00ADEE' : '', textDecoration: selectByTeam ? 'underline' : '', textUnderlinePosition: 'under', cursor: 'pointer' }}
                data-testid="AddByTeam" onClick={(e) => { e.preventDefault(); setSelectByTeam(!selectByTeam) }}
              >
                + Add By Team
              </div>
            </div>
            {formErrors?.staffIdTo && (
              <div
                style={{ width: "100%", textAlign: "left" }}
                className="form-error"
              >
                {formErrors?.staffIdTo}
              </div>
            )}
            {(inputVal?.length < 3 && inputVal != "") &&
              <div className="user-list" style={{ fontSize: 13 }}> Please enter at least 3 characters.</div>
            }
          </div>
          {/* ---------------------------------------------------------------------------------------------------------------- */}
        </div>

        <div className="meeting-name-container" data-testid="staffIdOptionalDropdown" onClick={() => { handleCloseControllRefDropdown() }}>
          <label for="" className="field-label">
            Optional:
          </label>
          <div
            className="meeting-name-inp to-relative"
            style={{ paddingLeft: "2px" }}
          >
            <Select
              isMulti={true}
              placeholder="Select"
              className="multiselect_email"
              value={formData?.staffIdOptional}
              styles={customStylesMulti}
              onChange={(item) => handleFormChange("staffIdOptional", item)}

              options={filteredToEmployeeData}
              inputValue={inputValOpt}
              onInputChange={(val) => { setInputValOpt(val) }}
              menuIsOpen={inputValOpt.length >= 3 ? true : false}
            />
            {(inputValOpt?.length < 3 && inputValOpt != "") &&
              <div className="user-list" style={{ fontSize: 13 }}> Please enter at least 3 characters.</div>
            }
          </div>
        </div>

        <div className="form-bottom">
          <div className="form-bottom-fields">
            <div className="start-time-container outer-date-container">
              <label for="" className="field-label">
                Start Time<span style={{ color: "red" }}>*</span>:
              </label>
              <div style={{ gridTemplateColumns: "17% 17% 30% 10% 26%", justifyContent: "flex-start" }} className="inputs" data-testid="StartTimeRefDropdown" onClick={() => handleCloseControllRefDropdown()}>
                <div className="inp-sub" style={{ backgroundColor: allDaySelected || isRecurranceSelected ? "#F2F2F2" : "white" }}>
                  <div className="inp" style={{ width: "100%" }}>
                    <div className="inp" style={{ width: "100%" }}>
                      <div className="date-picker" style={{ gap: "11px" }}
                      >
                        <span data-testid="StartTimeRefDropspan" onClick={() => document.getElementById("startDate").click()}
                        >
                          <svg
                            id="calendar-line-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="17px"
                            height="17px"
                            viewBox="0 0 27.119 27.122"
                          >
                            <path
                              id="Path_15922"
                              data-name="Path 15922"
                              d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                              fill="#00aff1"
                            />
                          </svg>
                        </span>
                        <DatePicker
                          disabled={isRecurranceSelected}
                          id="startDate"
                          name="startDate"
                          showTimeSelect={false}
                          selected={formData.startDate}
                          value={formData.startDate}
                          onChange={(date) => {
                            setFormData({ ...formData, endDate: date });
                            handleFormChange("startDate", date);

                          }}
                          dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                    {formErrors?.startDate && (
                      <div
                        style={{ width: "100%", textAlign: "left" }}
                        className="form-error"
                      >
                        {formErrors?.startDate}
                      </div>
                    )}
                  </div>

                </div>

                <div ref={newRef} data-testid="allDaySelecteddiv" onClick={() => { !allDaySelected && handleDropdownToggle() }} style={{ width: "8.5rem", backgroundColor: allDaySelected || isRecurranceSelected ? "#F2F2F2" : "white" }} className='dropDownDiv'>
                  <span style={{ margin: "2px -6px -5px 6px" }} >
                    <MdOutlineWatchLater color='#00AFF1' fontSize={"20px"} />
                  </span>
                  <span style={{ position: "relative" }} className='selectComp start-time-select-main' data-testid="allDaySelectedspan"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <CreatableSelect
                      options={startTimeArr}
                      isSearchable={true}
                      placeholder="Start time"
                      name="startTime"
                      isDisabled={isRecurranceSelected || allDaySelected}
                      value={formData.startTime}
                      isCreatable={true}
                      components={{ DropdownIndicator: null }}
                      onCreateOption={(val) =>
                         handleCreateOption(
                          val,
                          "outerStartTime", 
                          TimeArray,
                        formData,
                        setFormData,
                        handleFormChange,
                        setIndexOfStartTimeOuter,
                        addMoreHalfHours,
                        calculateTimeDifferenceOuter,
                        calculateTimeDifferenceInner,
                        formatTime2,
                        isStartTimeGreaterThanEndTime, // Only one instance now
                        addOneDay,
                        handleCloseControllRefDropdown,
                        Email,
                        filteredOptionalEmployeeData,
                        selectAllChecked,
                        setFilteredControllRef,
                        setDailyRecurrancePattern,
                        monthNames,
                        Currentdate,
                        setRecurranceErrors,
                        setMonthlyRecDayVal,
                        dailyRecurrancePattern,
                        setAllDaySelected,
                        setFormErrors,
                        setFailMessage,
                        setOpenFailModal,
                        validateInput,
                        isControlRefOpened
                      )
                    }

                      onChange={(e) => {
                        handleCloseControllRefDropdown();

                        setIndexOfStartTimeOuter(TimeArray.indexOf(e?.value));

                        handleTimeChangeLogic(
                          e,
                          e?.value,
                          TimeArray,
                          formData,
                          setFormData,
                          handleFormChange,
                          calculateTimeDifferenceOuter,
                          formatTime2,
                          isStartTimeGreaterThanEndTime,
                          addOneDay
                        );
                      }}

                      styles={customSelectStyles}
                      menuIsOpen={dropdownOpen}
                      onMenuOpen={() => setDropdownOpen(true)}
                      onMenuClose={() => setDropdownOpen(false)}
                    />
                    <span style={{ position: "absolute", right: "4px", top: "10px", color: "#727171" }} data-testid="FaAngleDownbutton" onClick={() => { !allDaySelected && handleDropdownToggle() }}><FaAngleDown size={11} style={{ marginBottom: '3px' }} color="black" /></span>
                  </span>
                  {formErrors?.startTime && (
                    <div
                      style={{ width: "100%", textAlign: "left", marginRight: "-18px" }}
                      className="form-error"
                    >
                      {formErrors?.startTime}
                    </div>
                  )}
                </div>
                <div
                  className="inp-sub-2"
                  style={{
                    alignItems: formErrors.complianceId
                      ? "flex-start"
                      : "center",
                    width: "22rem"
                  }}
                >
                  <div className="all-day">
                    <div className="field-label">
                      Compliance Tag<span style={{ color: "red" }}>*</span>:
                    </div>
                  </div>
                  <div style={{
                    width: "40%",
                    paddingLeft: "5px"
                  }}>
                    <div style={{ width: "100%" }}>
                      <select
                        style={{
                          width: "100%",
                          marginLeft: "0px",
                          height: "34px",
                          fontSize: "13px"
                        }}
                        name="complianceId"
                        data-testid="complianceId"
                        value={formData.complianceId}
                        onChange={(e) => {
                          handleFormChange("complianceId", e);
                        }}
                        onClick={(e) => {
                          setRecurringPop(false);
                        }}                      >
                        <option value="" disabled selected>
                          Select Compliance
                        </option>
                        {complianceTags?.map((item, index) => {
                          return (
                            <option key={index} value={item.complianceId}>
                              {item.complianceType}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {formErrors?.complianceId && (
                      <div
                        style={{ width: "100%", textAlign: "left" }}
                        className="form-error"
                      >
                        {formErrors?.complianceId}
                      </div>
                    )}
                  </div>
                </div>
                <div className="all-day" style={{ marginLeft: "-10px" }}>
                  <input
                    type="checkbox"
                    checked={formData.isAllDay}
                    name="isAllDay"
                    style={{ width: "20px", height: "auto" }}
                    data-testid="nearestTimeDay"
                    onChange={(e) => {
                      handleAllDayToggle(
                        formData.isAllDay,
                        nearestTime,
                        TimeArray,
                        setFormData,
                        handleFormChange,
                        formData
                      );
                    }}

                  />
                  <div className="field-label">All Day</div>
                </div>
                <div className="inp-sub-2">

                  <div className="time-zone" style={{ width: "70%" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.25px"
                      height="29.25"
                      viewBox="0 0 29.257 29.25"
                    >
                      <path
                        id="Icon_ionic-ios-globe"
                        data-name="Icon ionic-ios-globe"
                        d="M18,3.375h-.049a14.625,14.625,0,0,0,.007,29.25h.049A14.625,14.625,0,1,0,18,3.375ZM30.67,17.016H25.214a27.689,27.689,0,0,0-.689-5.358,21.42,21.42,0,0,0,3.495-1.477A12.6,12.6,0,0,1,30.67,17.016Zm-13.655,0H12.67a24.992,24.992,0,0,1,.619-4.859,21.392,21.392,0,0,0,3.727.5Zm0,1.969v4.352a21.482,21.482,0,0,0-3.727.5,24.989,24.989,0,0,1-.619-4.852Zm1.969,0h4.31a24.845,24.845,0,0,1-.619,4.845,20.988,20.988,0,0,0-3.691-.492Zm0-1.969V12.656a21.483,21.483,0,0,0,3.691-.492,24.919,24.919,0,0,1,.619,4.852Zm7.692-8.29A19.533,19.533,0,0,1,24,9.816a14.518,14.518,0,0,0-1.863-3.832A12.724,12.724,0,0,1,26.677,8.726Zm-4.528,1.6a19.788,19.788,0,0,1-3.164.422V5.583C20.18,6.23,21.347,7.966,22.148,10.322ZM17.016,5.555v5.182a19.447,19.447,0,0,1-3.2-.429C14.632,7.931,15.813,6.195,17.016,5.555ZM13.809,6a14.632,14.632,0,0,0-1.849,3.8A19.973,19.973,0,0,1,9.323,8.726,12.533,12.533,0,0,1,13.809,6ZM7.98,10.188a21,21,0,0,0,3.459,1.462,26.573,26.573,0,0,0-.689,5.358H5.337A12.532,12.532,0,0,1,7.98,10.188Zm-2.651,8.8h5.414a27.618,27.618,0,0,0,.689,5.358A22.277,22.277,0,0,0,7.973,25.8,12.6,12.6,0,0,1,5.33,18.984Zm3.987,8.29a19.678,19.678,0,0,1,2.644-1.083A14.684,14.684,0,0,0,13.809,30,12.845,12.845,0,0,1,9.316,27.274Zm4.5-1.589a19.549,19.549,0,0,1,3.2-.429v5.189C15.806,29.805,14.632,28.062,13.816,25.685Zm5.168,4.732V25.249a19.788,19.788,0,0,1,3.164.422C21.347,28.034,20.18,29.77,18.984,30.417Zm3.164-.4a14.518,14.518,0,0,0,1.863-3.832,19.211,19.211,0,0,1,2.672,1.1A12.87,12.87,0,0,1,22.148,30.016Zm5.871-4.2a21.42,21.42,0,0,0-3.495-1.477,27.545,27.545,0,0,0,.689-5.351H30.67A12.542,12.542,0,0,1,28.02,25.812Z"
                        transform="translate(-3.375 -3.375)"
                        fill="#00aff1"
                      />
                    </svg>
                    <div className="field-label">
                      Time Zones : {formData.timeZone}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop:
                  formErrors.startDate || formErrors.startTime ? "30px" : "",
              }}
              className="start-time-container outer-date-container"
            >
              <label for="" className="field-label">
                End Time<span style={{ color: "red" }}>*</span>:
              </label>

              <div style={{ gridTemplateColumns: "17% 17% 30% 29%", justifyContent: "flex-start", marginTop: "10px" }} className="inputs">
                {/* <div className="inp-sub"> */}
                <div className="inp" style={{ width: "100%" }}>
                  <div className="inp" style={{ width: "87%", backgroundColor: allDaySelected || isRecurranceSelected ? "#F2F2F2" : "white" }}>
                    <div className="date-picker" data-testid="allDaySelecteddatepicker" style={{ gap: "11px" }} onClick={() => handleCloseControllRefDropdown()}>
                      <span style={{ paddingTop: 2 }} data-testid="allDaySelecteddatepickerspan" onClick={() => document.getElementById("endDate").click()}
                      >
                        <svg
                          id="calendar-line-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="17px"
                          height="17px"
                          viewBox="0 0 27.119 27.122"
                        >
                          <path
                            id="Path_15922"
                            data-name="Path 15922"
                            d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                            fill="#00aff1"
                          />
                        </svg>
                      </span>
                      <DatePicker
                        id="endDate"
                        name="endDate"
                        disabled={isRecurranceSelected}
                        minDate={formData.startDate}
                        showTimeSelect={false}
                        selected={formData.endDate}
                        value={formData.endDate}
                        onChange={(date) => handleFormChange("endDate", date)}

                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </div>
                  {formErrors?.endDate && (
                    <div
                      style={{ width: "100%", textAlign: "left" }}
                      className="form-error"
                    >
                      {formErrors?.endDate}
                    </div>
                  )}
                </div>

                <div ref={newRef2} className='dropDownDiv' data-testid="allDaySelectednewRef2" onClick={() => { !allDaySelected && handleDropdownToggle2() }} style={{ width: "89%", backgroundColor: allDaySelected || isRecurranceSelected ? "#F2F2F2" : "white" }}>
                  <span style={{ margin: "2px -6px -5px 6px" }} >
                    <MdOutlineWatchLater color='#00AFF1' fontSize={"20px"} />
                  </span>
                  <span style={{ position: "relative" }} className='selectComp' data-testid="allDaySelectednewRef2span" onClick={(e) => {
                    e.stopPropagation();
                    handleCloseControllRefDropdown();
                  }}>
                    <CreatableSelect
                      id="endTime"
                      name="endTime"
                      options={optionsEnd}
                      placeholder="End time"
                      isDisabled={isRecurranceSelected || allDaySelected}
                      value={formData.endTime}
                      isSearchable={true}
                      isCreatable={true}
                      components={{ DropdownIndicator: null }}
                      onCreateOption={(val) => handleCreateOption(
                        val,
                        "outerEndTime",
                        TimeArray,
                        formData,
                        setFormData,
                        handleFormChange,
                        setIndexOfStartTimeOuter,
                        addMoreHalfHours,
                        calculateTimeDifferenceOuter,
                        calculateTimeDifferenceInner,
                        formatTime2,
                        isStartTimeGreaterThanEndTime,
                        addOneDay,
                        handleCloseControllRefDropdown,
                        Email,
                        filteredOptionalEmployeeData, // Keep this
                        selectAllChecked,
                        setFilteredControllRef,
                        setDailyRecurrancePattern,
                        monthNames,
                        Currentdate,
                        setRecurranceErrors,
                        setMonthlyRecDayVal,
                        dailyRecurrancePattern,
                        setAllDaySelected,
                        setFormErrors,
                        setFailMessage,
                        setOpenFailModal,
                        validateInput,
                        isControlRefOpened
                      )}


                      onClick={() => handleCloseControllRefDropdown()}
                      onChange={(e) => {
                        handleFormChange("endTime", e);

                        calculateTimeDifferenceOuter(
                          formData?.startTime?.value,
                          e?.value,
                          formData,
                          setFormData,
                          formatTime2,
                          isStartTimeGreaterThanEndTime,
                          addOneDay
                        );
                      }}
                      styles={customSelectStyles}
                      menuIsOpen={dropdownOpen2}
                      onMenuOpen={() => setDropdownOpen2(true)}
                      onMenuClose={() => setDropdownOpen2(false)}
                    />
                    <span style={{ position: "absolute", right: "4px", top: "10px", color: "#727171" }} data-testid="DepartmentTagFaAngleDown" onClick={() => { !allDaySelected && handleDropdownToggle2() }}><FaAngleDown size={11} style={{ marginBottom: '3px' }} color="black" /></span>
                  </span>
                  {formErrors?.endTime && (
                    <div
                      style={{ width: "100%", textAlign: "left", marginRight: "-18px" }}
                      className="form-error"
                    >
                      {formErrors?.endTime}
                    </div>
                  )}
                </div>
                {/* </div> */}
                <div
                  className="inp-sub" style={{ justifyContent: "flex-start", width: "100%" }}>
                  <label style={{ fontSize: "14px", width: "39%" }} htmlFor="Department Tag">Department Tag <span style={{ color: "red" }}>*</span>:</label>
                  <div className="inp" style={{ width: "55%" }}>
                    <div className="inp" style={{ width: "92%" }}>
                      <select
                        name="deptTagId"
                        id=""
                        data-testid="deptTagIdid"
                        value={formData.deptTagId}
                        onChange={(e) => {
                          handleFormChange("deptTagId", e);
                        }}
                        onClick={handleDepartTag}
                      >
                        <option value="" disabled selected>
                          Select Department
                        </option>
                        {departmentTags?.map((item, index) => {
                          return (
                            <option key={index} value={item.deptTagId}>
                              {item.deptTag}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {formErrors?.deptTagId && (
                      <div
                        style={{ width: "100%", textAlign: "left" }}
                        className="form-error"
                      >
                        {formErrors?.deptTagId}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="inp-sub"
                  style={{
                    display: "flex",
                    alignItems: formErrors.complianceId
                      ? "flex-start"
                      : "center",
                    // width: "13rem"
                  }}

                >
                  <label style={{ marginLeft: "-7px" }} htmlFor="timePicker" className="field-label">
                    Location<span style={{ color: "red" }}>*</span>:
                  </label>
                  <div className="inp" style={{ paddingLeft: "27px", width: "15rem" }}>

                    <select
                      name="meetingLocation"
                      id=""
                      data-testid="meetingLocation"
                      value={formData.meetingLocation}
                      onChange={(e) => {
                        handleFormChange("meetingLocation", e);

                      }}
                      onClick={() => handleCloseControllRefDropdown()}
                    >
                      <option value="" disabled selected>
                        Select Location
                      </option>

                      {locations?.map((item, index) => {
                        return (
                          <option key={item.locationId} value={item.locationId}>
                            {item.location}
                          </option>
                        );
                      })}


                    </select>
                    {formErrors?.meetingLocation && (
                      <div
                        style={{ width: "100%", textAlign: "left" }}
                        className="form-error"
                      >
                        {formErrors?.meetingLocation}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="start-time-container"
              style={{
                marginTop:
                  formErrors.endDate || formErrors.endTime ? "30px" : "",
              }}
            >
              <label

                for="" className="field-label">
                Recurring

                {/* <span style={{ color: "red" }}>*</span> */}
                :
              </label>
              <div className="inputs">
                <div className="inp-sub-2">
                  <div className="all-day">

                  </div>
                  <div style={{ width: "100%" }}>
                    <div
                      className="recurring-container"
                      style={{ fontWeight: "normal", fontSize: "13px", paddingLeft: 0 }}
                    >

                      {
                        isRecurranceSelected || recPatternString
                          ? <span onClick={() => {
                            !recurringPop && setRecurringPop(true);
                          }} data-testid="setRecurringPop"
                            style={{ fontSize: "13px", display: "flex", alignItems: "center", color: "#00ADEE" }} className="recurrance-span">{disableRec ? "View Recurrance" : "Edit Recurrence"}&nbsp;&nbsp;<FaArrowsRotate fill="00ADEE" />&nbsp;&nbsp;<span style={{ color: "black" }}>{recPatternString}</span></span>
                          : <span onClick={() => {
                            !recurringPop && setRecurringPop(true);
                          }} style={{ fontSize: "13px", display: "flex", alignItems: "center", color: "#00ADEE" }} className="recurrance-span">Make Recurrence&nbsp;<FaArrowsRotate fill="00ADEE" /> </span>
                      }
                      {recurringPop == true && (
                        <div className="recurring-popup-container" style={{ height: '425px', zIndex: '1' }}>
                          <div
                            className="recurring-close-button"
                            style={{ zIndex: 12 }}
                            data-testid="recurring-close-button"
                            onClick={() => handlerecurranceClose(
                              recRememberValues,
                              setRecurringPop,
                              setFormData,
                              setRecurranceErrors,
                              formData,
                              monthNames,
                              Currentdate,
                              recPatternString
                            )}
                          >
                            <AiOutlineClose fill="#00ACEC" />
                          </div>
                          <div className="recurring-popup-inner">
                            <p className="recurring-title">
                              Appointment Reccurrence
                            </p>
                            <div className="appointment-time-container">
                              <div className="apointment-inner-header">
                                <p>Appointment Time</p>
                                <hr />
                              </div>
                              <div className="fields">
                                <div className="field">
                                  <label htmlFor="">Start<span style={{ color: "red" }}>*</span>:</label>
                                  {/*-----------------------------------------------Recurrance start-------------------------------------------------------- */}
                                  <div className={'dropDownDiv2'} ref={RecRef}>

                                    <span className='selectComp' style={{ position: "relative" }}>
                                      <CreatableSelect
                                        options={optionsStartRecurrance}
                                        placeholder="Start"
                                        name="recStartTime"
                                        isDisabled={disableRec || formData?.isAllDay}
                                        value={formData.recStartTime}
                                        isSearchable={true}
                                        isCreatable={true}
                                        components={{ DropdownIndicator: null }}
                                        onCreateOption={(val) => handleCreateOption(
                                          val,
                                          "recurranceStartTime",
                                          TimeArray,
                                          formData,
                                          setFormData,
                                          handleFormChange,
                                          setIndexOfStartTimeOuter,
                                          addMoreHalfHours,
                                          calculateTimeDifferenceOuter,
                                          calculateTimeDifferenceInner,
                                          formatTime2,
                                          isStartTimeGreaterThanEndTime,
                                          addOneDay,
                                          handleCloseControllRefDropdown,
                                          Email,
                                          filteredOptionalEmployeeData, // Retain this
                                          selectAllChecked,
                                          setFilteredControllRef,
                                          setDailyRecurrancePattern,
                                          monthNames,
                                          Currentdate,
                                          setRecurranceErrors,
                                          setMonthlyRecDayVal,
                                          dailyRecurrancePattern,
                                          setAllDaySelected,
                                          setFormErrors,
                                          setFailMessage,
                                          setOpenFailModal,
                                          validateInput,
                                          isControlRefOpened
                                        )}


                                        onChange={(e) => {



                                          let d = TimeArray.indexOf(e?.value) == TimeArray.length - 1 ? {
                                            label: TimeArray[0],
                                            value:
                                              TimeArray[0],
                                            isDisabled: false,
                                          }
                                            :
                                            {
                                              label: TimeArray[
                                                TimeArray.indexOf(e?.value) + 1
                                              ],
                                              value:
                                                TimeArray[
                                                TimeArray.indexOf(e?.value) + 1
                                                ],
                                              isDisabled: false,
                                            }

                                          setFormData({
                                            ...formData,
                                            recEndTime: d
                                          });
                                          handleFormChange("recStartTime", e);

                                          let et = TimeArray.indexOf(e?.value) == TimeArray.length - 1 ? TimeArray[0] : TimeArray[TimeArray.indexOf(e?.value) + 1]

                                          calculateTimeDifferenceInner(
                                            e?.value,
                                            et,
                                            formData,
                                            setFormData,
                                            formatTime2,
                                            isStartTimeGreaterThanEndTime,
                                            addOneDay
                                          );
                                        }}

                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,
                                            border: recurranceErrors?.recStartTime ? "1px solid red" : '1px solid gray',
                                            minHeight: "26px",
                                            borderRadius: '5px',
                                            height: '15px',
                                            fontSize: '12px',

                                            marginLeft: "-6px",
                                            color: "black",
                                            width: '102px',
                                            boxShadow: state.isFocused ? 'none' : state.isHovered ? '0 0 0 2px #00aff1' : 'none',
                                            '&:hover': {
                                              borderColor: state.isFocused ? '#00aff1' : '#ccc'
                                            }
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            // backgroundColor: state.isSelected ? '#00aff1' : 'white',
                                            color: state.isSelected ? 'white' : 'black',
                                            fontSize: '12px',
                                            '&:hover': {
                                              backgroundColor: '#00000029',
                                              color: 'white'
                                            }
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            width: '102px',
                                            maxHeight: '200px',
                                            zIndex: 9999
                                          }),
                                          menuList: (provided) => ({
                                            ...provided,
                                            maxHeight: '125px',
                                            overflowY: 'auto'
                                          })
                                        }}
                                        menuIsOpen={RcurDropdownOpen}
                                        onMenuOpen={() => setRcurDropdownOpen(true)}
                                        onMenuClose={() => setRcurDropdownOpen(false)}
                                      />
                                      <span style={{ position: "absolute", right: "3px", top: "7px", color: "#727171" }} onClick={() => handleDropdownToggleRec(RcurDropdownOpen, setRcurDropdownOpen, setRcurDropdownOpen2)}><FaAngleDown /></span>

                                    </span>

                                  </div>
                                  {/* ------------------------------------------------------------------------------------------------------- */}
                                </div>
                                <div className="field">
                                  <label htmlFor="">End<span style={{ color: "red" }}>*</span>:</label>

                                  {/* -------------------------------------------------------------------------------------------- */}
                                  <div className='dropDownDiv2' ref={RecRef2}>
                                    <span className='selectComp' style={{ position: "relative" }}>
                                      <CreatableSelect
                                        name="recEndTime"
                                        options={optionsEndRecurrance}
                                        placeholder="End"
                                        isDisabled={disableRec || !formData?.recStartTime?.value || formData.isAllDay}
                                        value={formData.recEndTime}
                                        isSearchable={true}
                                        isCreatable={true}
                                        components={{ DropdownIndicator: null }}
                                        onCreateOption={(val) => handleCreateOption(
                                          val,
                                          "recurranceEndTime",
                                          TimeArray,
                                          formData,
                                          setFormData,
                                          handleFormChange,
                                          setIndexOfStartTimeOuter,
                                          addMoreHalfHours,
                                          calculateTimeDifferenceOuter,
                                          calculateTimeDifferenceInner,
                                          formatTime2,
                                          isStartTimeGreaterThanEndTime,
                                          addOneDay,
                                          handleCloseControllRefDropdown,
                                          Email,
                                          filteredOptionalEmployeeData, // Retain this argument
                                          selectAllChecked,
                                          setFilteredControllRef,
                                          setDailyRecurrancePattern,
                                          monthNames,
                                          Currentdate,
                                          setRecurranceErrors,
                                          setMonthlyRecDayVal,
                                          dailyRecurrancePattern,
                                          setAllDaySelected,
                                          setFormErrors,
                                          setFailMessage,
                                          setOpenFailModal,
                                          validateInput,
                                          isControlRefOpened
                                        )}


                                        onChange={(e) => {
                                          handleFormChange("recEndTime", e);

                                          calculateTimeDifferenceInner(
                                            formData?.recStartTime?.value,
                                            e?.value,
                                            formData,
                                            setFormData,
                                            formatTime2,
                                            isStartTimeGreaterThanEndTime,
                                            addOneDay
                                          );
                                        }}
                                        // disabled={disableRec}
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,
                                            // border: recurranceErrors?.recEndTime ? "1px solid red" : '1px solid gray',
                                            border: recurranceErrors?.recStartTime ? "1px solid red" : '1px solid gray',

                                            minHeight: "26px",
                                            borderRadius: '5px',
                                            height: '15px',
                                            fontSize: '12px',
                                            marginLeft: "-6px",
                                            color: "black",
                                            width: '102px',
                                            boxShadow: state.isFocused ? 'none' : state.isHovered ? '0 0 0 2px #00aff1' : 'none',
                                            '&:hover': {
                                              borderColor: state.isFocused ? '#00aff1' : '#ccc'
                                            }
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            // backgroundColor: state.isSelected ? '#00aff1' : 'white',
                                            color: state.isSelected ? 'white' : 'black',
                                            fontSize: '12px',
                                            '&:hover': {
                                              backgroundColor: '#00000029',
                                              color: 'white'
                                            }
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            width: '102px',
                                            maxHeight: '200px',
                                            zIndex: 9999
                                          }),
                                          menuList: (provided) => ({
                                            ...provided,
                                            maxHeight: '125px',
                                            overflowY: 'auto'
                                          })
                                        }}
                                        menuIsOpen={RcurDropdownOpen2}
                                        onMenuOpen={() => setRcurDropdownOpen2(true)}
                                        onMenuClose={() => setRcurDropdownOpen2(false)}
                                      />
                                      <span style={{ position: "absolute", right: "3px", top: "7px", color: "#727171" }} onClick={() => {
                                        formData?.recStartTime?.value && handleDropdownToggle2Rec(RcurDropdownOpen2, setRcurDropdownOpen2, setRcurDropdownOpen);
                                      }}><FaAngleDown /></span>
                                    </span>

                                  </div>
                                  {/* -------------------------------------------------------------------------------------------- */}
                                </div>
                                <div className="field">
                                  <label htmlFor="" style={{ width: "40%" }}>Duration :</label>
                                  <p>{formData.recDurationMinutes}</p>

                                </div>
                              </div>
                            </div>
                            <div className="range-pattern-container">
                              <div className="apointment-inner-header">
                                <p>Recurrence Pattern
                                  <span style={{ color: "red" }}>*</span>:
                                </p>
                                <hr />
                              </div>
                              <div className="recurrance-pattern-radios">
                                <label style={{ display: "flex", gap: 5 }}>
                                  <input
                                    type="radio"
                                    name="recRecurrenceType"
                                    value={"Daily"}
                                    checked={
                                      formData.recRecurrenceType === "Daily"
                                    }
                                    onChange={(e) =>
                                      handleFormChange("recRecurrenceType", e)

                                    }
                                    disabled={disableRec}
                                  />{" "}
                                  Daily
                                </label>
                                <label style={{ display: "flex", gap: 5 }}>
                                  <input
                                    type="radio"
                                    name="recRecurrenceType"
                                    value={"Weekly"}
                                    checked={
                                      formData.recRecurrenceType === "Weekly"
                                    }
                                    onChange={(e) =>
                                      handleFormChange("recRecurrenceType", e)

                                    }
                                    disabled={disableRec}
                                  />{" "}
                                  Weekly
                                </label>
                                <label style={{ display: "flex", gap: 5 }}>
                                  <input
                                    type="radio"
                                    name="recRecurrenceType"
                                    value={"Monthly"}
                                    checked={
                                      formData.recRecurrenceType === "Monthly"
                                    }
                                    onChange={(e) =>
                                      handleFormChange("recRecurrenceType", e)

                                    }
                                    disabled={disableRec}
                                  />{" "}
                                  Monthly
                                </label>
                                <label style={{ display: "flex", gap: 5 }}>
                                  <input
                                    type="radio"
                                    name="recRecurrenceType"
                                    value={"Yearly"}
                                    checked={
                                      formData.recRecurrenceType === "Yearly"
                                    }
                                    onChange={(e) =>
                                      handleFormChange("recRecurrenceType", e)

                                    }
                                    disabled={disableRec}
                                  />{" "}
                                  Yearly
                                </label>
                              </div>
                              {formData.recRecurrenceType === "Daily" ? (
                                <div className="daily-recurrance-pattern-main">
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "10px",
                                      alignItems: "center"
                                    }}
                                  >
                                    <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 5 }}>
                                      <input
                                        type="radio"
                                        name="EveryDay"
                                        value={"EveryDay"}
                                        checked={
                                          dailyRecurrancePattern === "EveryDay"
                                        }
                                        onChange={(e) => handle_daily_recurrance_type(e, setDailyRecurrancePattern, setFormData)}
                                        disabled={disableRec}
                                      />{" "}
                                      Every
                                      {/* <span style={{ color: "red" }}>*</span>: */}
                                    </label>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: recurranceErrors?.recRecurrenceInterval ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      type="number"
                                      maxLength={99}
                                      name={"recRecurrenceInterval"}
                                      disabled={
                                        dailyRecurrancePattern ===
                                        "EveryWeek" || disableRec
                                      }
                                      value={
                                        dailyRecurrancePattern != "EveryDay"
                                          ? ""
                                          : formData?.recRecurrenceInterval
                                      }
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recRecurrenceInterval",
                                          e)
                                      }
                                    />
                                    <span style={{ fontSize: 12 }}>day(s)</span>
                                  </div>
                                  <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 5 }}>
                                    <input
                                      type="radio"
                                      name="EveryWeek"
                                      value={"EveryWeek"}
                                      checked={
                                        dailyRecurrancePattern === "EveryWeek"
                                      }
                                      onChange={(e) => handle_daily_recurrance_type(e, setDailyRecurrancePattern, setFormData)}
                                      disabled={disableRec}
                                    />{" "}
                                    Every Weekday
                                  </label>
                                </div>
                              ) : formData.recRecurrenceType === "Weekly" ? (
                                <div className="Weekly-recurrance-pattern-main">
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <span style={{ fontSize: 12 }}>
                                      Recur Every
                                      {/* <span style={{ color: "red" }}>*</span>: */}
                                    </span>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: recurranceErrors?.recRecurrenceInterval ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      maxLength={2}
                                      type="number"
                                      name={"recRecurrenceInterval"}
                                      disabled={
                                        weeklyRecurrancePattern ===
                                        "EveryWeek" || disableRec
                                      }
                                      value={formData?.recRecurrenceInterval}
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recRecurrenceInterval",
                                          e,
                                        )
                                      }
                                    />
                                    <span style={{ fontSize: 12 }}>
                                      Week(s) On :
                                    </span>
                                  </div>
                                  <div className="weekly-checkbox-container">
                                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 10 }}>

                                      <div className="select-All-check">
                                        <span style={{ fontSize: 12 }}>
                                          Select All
                                        </span>
                                        <input
                                          type="checkbox"
                                          name="selectAllWeekDays"
                                          checked={formData.recDays.isMonday && formData.recDays.isTuesday && formData.recDays.isWednesday && formData.recDays.isThursday && formData.recDays.isFriday && formData.recDays.isSaturday && formData.recDays.isSunday}
                                          value={selectAllWeekDays}
                                          onChange={(e) => {
                                            // setSelectAllWeekDays(
                                            //   !selectAllWeekDays
                                            // )
                                            handleSelectAllDays(formData, setFormData, validateRecurrance, dailyRecurrancePattern, setRecurranceErrors);
                                          }
                                          }
                                          disabled={disableRec}
                                        />
                                      </div>
                                      <div className="check-boxes">
                                        {daysOfWeek?.map((day, index) => {
                                          return (
                                            <div className="checkField">
                                              <input
                                                type="checkbox"
                                                name={`is${day}`}
                                                value={
                                                  formData?.recDays[`is${day}`]
                                                }
                                                checked={
                                                  formData?.recDays[`is${day}`]
                                                }
                                                onChange={(e) =>
                                                  handleFormChange(`is${day}`, e)
                                                }
                                                disabled={disableRec}
                                              />{" "}
                                              <span>{day}</span>
                                            </div>
                                          );
                                        })}
                                      </div>

                                    </div>
                                    {recurranceErrors.recDays &&
                                      <div style={{ color: "red", fontSize: 13, marginTop: 3 }}>
                                        Please seleact at least one day
                                      </div>}
                                  </div>

                                </div>
                              ) : formData.recRecurrenceType === "Monthly" ? (
                                <div className="monthly-recurrance-pattern-main">
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "10px",
                                    }}
                                  >
                                    <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 5 }}>
                                      <input
                                        style={{ fontSize: 12 }}
                                        type="radio"
                                        name="EveryDay"
                                        value={"EveryDay"}
                                        checked={
                                          monthlyRecurrancePattern ===
                                          "EveryDay"
                                        }
                                        onChange={(e) =>
                                          handle_monthly_recurrance_type(
                                            e,
                                            "monthlyFirstTab",
                                            setMonthlyRecurrancePattern,
                                            setFormData,
                                            setMonthlyRecDayVal
                                          )
                                        }
                                        disabled={disableRec}
                                      />{" "}
                                      Day
                                    </label>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: (recurranceErrors?.recDayOfMonth && monthlyRecurrancePattern == "EveryDay") ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      type="number"
                                      maxLength={2}
                                      name={"recDayOfMonth"}
                                      disabled={
                                        monthlyRecurrancePattern !=
                                        "EveryDay" || disableRec
                                      }
                                      value={
                                        monthlyRecurrancePattern == "EveryDay"
                                          ? formData.recDayOfMonth
                                          : ""
                                      }
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recDayOfMonth",
                                          e.target.value)
                                      }
                                    />
                                    <span
                                      style={{ fontSize: 12 }}
                                      className="field-span"
                                    >
                                      of every
                                    </span>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: (recurranceErrors?.recRecurrenceInterval && monthlyRecurrancePattern == "EveryDay") ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      type="number"
                                      maxLength={2}
                                      name={"recRecurrenceInterval"}
                                      disabled={
                                        monthlyRecurrancePattern !=
                                        "EveryDay" || disableRec
                                      }
                                      value={
                                        monthlyRecurrancePattern == "EveryDay"
                                          ? formData?.recRecurrenceInterval
                                          : ""
                                      }
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recRecurrenceInterval",
                                          e)
                                      }
                                    />
                                    <span style={{ fontSize: 12 }}>
                                      Month(s)
                                    </span>
                                  </div>
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "10px",
                                    }}
                                  >
                                    <label style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                      <input
                                        type="radio"
                                        name="EveryWeekDay"
                                        value={"EveryWeekDay"}
                                        checked={
                                          monthlyRecurrancePattern ===
                                          "EveryWeekDay"
                                        }
                                        onChange={(e) =>
                                          handle_monthly_recurrance_type(
                                            e,
                                            "monthlySecondTab",
                                            setMonthlyRecurrancePattern,
                                            setFormData,
                                            setMonthlyRecDayVal
                                          )
                                        }
                                        disabled={disableRec}
                                      />
                                      <span style={{ fontSize: 12 }}>The</span>
                                    </label>

                                    <select
                                      placeholder="Select Time"
                                      value={formData?.recWeekNoId}
                                      name="recWeekNoId"
                                      id=""
                                      disabled={
                                        monthlyRecurrancePattern !=
                                        "EveryWeekDay" || disableRec
                                      }
                                      onChange={(e) =>
                                        handleFormChange("recWeekNoId", e)
                                      }
                                    >
                                      {weekGaps?.map((item, index) => {
                                        return (
                                          <option key={index}>{item}</option>
                                        );
                                      })}
                                    </select>
                                    <select
                                      placeholder="Select Time"
                                      name="MonthlyRecDayChange"
                                      value={monthlyRecDayVal}
                                      id=""
                                      disabled={
                                        monthlyRecurrancePattern !=
                                        "EveryWeekDay" || disableRec
                                      }
                                      onChange={(e) => {
                                        setMonthlyRecDayVal(e.target.value);
                                        handleFormChange(
                                          "MonthlyRecDayChange",
                                          e);
                                      }}
                                    >
                                      {daysOfWeek?.map((item) => {
                                        return <option>{item}</option>;
                                      })}
                                    </select>
                                    <span style={{ fontSize: 12 }}>
                                      of every
                                    </span>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: (recurranceErrors.recRecurrenceInterval && monthlyRecurrancePattern !== "EveryDay") ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      type="number"
                                      maxLength={2}
                                      name={"recRecurrenceInterval"}
                                      disabled={
                                        monthlyRecurrancePattern !=
                                        "EveryWeekDay" || disableRec
                                      }
                                      value={
                                        monthlyRecurrancePattern ==
                                          "EveryWeekDay"
                                          ? formData?.recRecurrenceInterval
                                          : ""
                                      }
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recRecurrenceInterval",
                                          e)
                                      }
                                    />
                                    <span style={{ fontSize: 12 }}>
                                      Month(s)
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <div className="monthly-recurrance-pattern-main">
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <label>
                                      <span style={{ fontSize: 12 }}>
                                        Recur Every
                                        {/* <span style={{ color: "red" }}>*</span>: */}
                                      </span>
                                    </label>
                                    <input
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: recurranceErrors?.recRecurrenceInterval ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      maxLength={2}
                                      type="number"
                                      name={"recRecurrenceInterval"}
                                      value={formData?.recRecurrenceInterval}
                                      onChange={(e) =>
                                        handleFormChange(
                                          "recRecurrenceInterval",
                                          e)
                                      }
                                      disabled={disableRec}
                                    />
                                    <span style={{ fontSize: 12 }}>
                                      Year(s)
                                    </span>
                                  </div>
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "10px",
                                    }}
                                  >
                                    <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 5 }}>
                                      <input
                                        type="radio"
                                        name="YearFirstTab"
                                        value={"YearFirstTab"}
                                        checked={
                                          yearlyRecurrancePattern ===
                                          "YearFirstTab"
                                        }
                                        onChange={(e) =>
                                          handle_yearly_recurrance_type(
                                            e,
                                            "YearFirstTab",
                                            setYearlyRecurrancePattern,
                                            setFormData,
                                            setMonthlyRecDayVal
                                          )
                                        }
                                        disabled={disableRec}
                                      />{" "}
                                      On
                                    </label>
                                    <select
                                      placeholder=""
                                      disabled={
                                        yearlyRecurrancePattern !=
                                        "YearFirstTab" || disableRec
                                      }
                                      name="recMonthOfYear"
                                      value={
                                        yearlyRecurrancePattern !=
                                          "YearFirstTab"
                                          ? ""
                                          : formData.recMonthOfYear
                                      }
                                      onChange={(e) =>
                                        handleFormChange("recMonthOfYear", e)
                                      }
                                    >
                                      {monthNames?.map((item, index) => {
                                        return (
                                          <option key={index}>{item}</option>
                                        );
                                      })}
                                    </select>
                                    {/* <span className='field-span' >of every</span> */}

                                    <input
                                      className="yearly_input_day"
                                      placeholder="DD"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "3px",
                                        border: (recurranceErrors?.recDayOfMonth && yearlyRecurrancePattern == "YearFirstTab") ? "1px solid red" : "1px solid gray",
                                        outline: "none",
                                        textAlign: "center",
                                      }}
                                      maxLength="2"
                                      type="number"
                                      name={"recDayOfMonth"}
                                      disabled={
                                        yearlyRecurrancePattern !=
                                        "YearFirstTab" || disableRec
                                      }
                                      value={
                                        yearlyRecurrancePattern !=
                                          "YearFirstTab"
                                          ? ""
                                          : formData.recDayOfMonth
                                      }
                                      onChange={(e) =>
                                        handleFormChange("recDayOfMonth", e)
                                      }
                                    />
                                    {/* <span>year(s)</span> */}
                                  </div>
                                  <div
                                    className="patttern-field"
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "8px",
                                    }}
                                  >
                                    <label style={{ fontSize: 12, display: "flex", alignItems: "center", gap: 5 }}>
                                      <input
                                        type="radio"
                                        name="YearSecondTab"
                                        value={"YearSecondTab"}
                                        checked={
                                          yearlyRecurrancePattern ===
                                          "YearSecondTab"
                                        }
                                        onChange={(e) =>
                                          handle_yearly_recurrance_type(
                                            e,
                                            "YearSecondTab",
                                            setYearlyRecurrancePattern,
                                            setFormData,
                                            setMonthlyRecDayVal
                                          )
                                        }
                                        disabled={disableRec}
                                      />{" "}
                                      On The
                                    </label>

                                    <select
                                      placeholder="Select Time"
                                      disabled={
                                        yearlyRecurrancePattern !=
                                        "YearSecondTab" || disableRec
                                      }
                                      name="recWeekNoId"
                                      id=""
                                      value={formData?.recWeekNoId}
                                      onChange={(e) =>
                                        handleFormChange("recWeekNoId", e)
                                      }
                                    >
                                      {weekGaps?.map((item, index) => {
                                        return (
                                          <option key={index}>{item}</option>
                                        );
                                      })}
                                    </select>
                                    <select
                                      placeholder="Select Time"
                                      disabled={
                                        yearlyRecurrancePattern !=
                                        "YearSecondTab" || disableRec
                                      }
                                      name="MonthlyRecDayChange"
                                      value={monthlyRecDayVal}
                                      onChange={(e) => {
                                        setMonthlyRecDayVal(e.target.value);
                                        handleFormChange(
                                          "MonthlyRecDayChange",
                                          e);
                                      }}
                                    >
                                      {daysOfWeek?.map((item, index) => {
                                        return (
                                          <option key={index}>{item}</option>
                                        );
                                      })}
                                    </select>
                                    <span>of</span>
                                    <select
                                      placeholder="Select Time"
                                      disabled={
                                        yearlyRecurrancePattern !=
                                        "YearSecondTab" || disableRec
                                      }
                                      name="recMonthOfYear"
                                      value={
                                        yearlyRecurrancePattern !=
                                          "YearSecondTab"
                                          ? ""
                                          : formData.recMonthOfYear
                                      }
                                      onChange={(e) =>
                                        handleFormChange("recMonthOfYear", e)
                                      }
                                    >
                                      {monthNames?.map((item, index) => {
                                        return (
                                          <option key={index}>{item}</option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="range-occurence-container">
                              <div
                                className="apointment-inner-header"
                                style={{ width: "100%" }}
                              >
                                <p>Range Of Recurrence<span style={{ color: "red" }}>*</span>:</p>
                                <hr />
                              </div>
                              <div className="range-ocurrance-inner">
                                <div className="range-occurance-field"
                                  onClick={() =>
                                    handleOpenCloseRecurranceStart(
                                      recurranceStartDatePicker,
                                      setOpenRecurranceStartDatePicker,
                                      setOpenRecurranceEndDatePicker
                                    )
                                  }
                                  onBlur={() => setTimeout(() => { setOpenRecurranceStartDatePicker(false) }, 500)}
                                >
                                  <label htmlFor="startDateSelector">
                                    Start&nbsp;:
                                  </label>
                                  <div className="select-container recurrance-date-select">
                                    <span style={{ fontSize: "11px", visibility: "hidden" }}>
                                      {moment(formData.recStartDate).format(
                                        "dddd"
                                      )}{" "}
                                      {moment(formData.recStartDate).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </span>
                                    <AiOutlineRight

                                    />
                                    {/* {recurranceStartDatePicker == true && ( */}
                                    <DatePicker
                                      key={formData?.recStartDate}
                                      name="recStartDate"
                                      popperPlacement="top-start"
                                      // open={recurranceStartDatePicker}
                                      showTimeSelect={false}
                                      selected={formData?.recStartDate}
                                      value={formData?.recStartDate}
                                      onChange={(date) => {
                                        handle_rec_start_date(date, handleFormChange,
                                          setOpenRecurranceStartDatePicker,
                                          formData,
                                          Email,
                                          setFormData,
                                          filteredOptionalEmployeeData,
                                          setFilteredToEmployeeData,
                                          selectAllChecked,
                                          setFilteredControllRef,
                                          setDailyRecurrancePattern,
                                          monthNames,
                                          Currentdate,
                                          setRecurranceErrors,
                                          setMonthlyRecDayVal,
                                          dailyRecurrancePattern,
                                          setAllDaySelected,
                                          setFormErrors,
                                          setFailMessage,
                                          setOpenFailModal,
                                          isStartTimeGreaterThanEndTime,
                                          validateInput,
                                          isControlRefOpened);
                                      }
                                      }
                                      disabled={disableRec}
                                      // readOnly={flow == "UpcomingMeetings" || flow == "CancelledMeetings"}
                                      dateFormat='EEEE dd-MM-yyyy'
                                    />
                                    {/* )} */}
                                  </div>
                                </div>
                                <div className="range-occurance-field"
                                  onClick={() =>
                                    handleOpenCloseRecurranceEnd(
                                      recurranceEndDatePicker,
                                      setOpenRecurranceEndDatePicker,
                                      setOpenRecurranceStartDatePicker
                                    )
                                  }
                                  onBlur={() => setTimeout(() => { setOpenRecurranceEndDatePicker(false) }, 500)}
                                >
                                  <label htmlFor="endDateSelector">
                                    End by :
                                  </label>
                                  <div className="select-container">
                                    <span style={{ fontSize: "11px", visibility: "hidden" }}>
                                      {moment(formData.recEndDate).format(
                                        "dddd"
                                      )}{" "}
                                      {moment(formData.recEndDate).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </span>
                                    <AiOutlineRight

                                    />
                                    {/* {recurranceEndDatePicker == true && ( */}
                                    <DatePicker
                                      name="recEndDate"
                                      // open={recurranceEndDatePicker}
                                      showTimeSelect={false}
                                      minDate={formData.recStartDate}
                                      popperPlacement="top-end"
                                      selected={formData.recEndDate}
                                      value={formData.recEndDate}
                                      onChange={(date) => {
                                        handle_rec_end_date(
                                          date,
                                          handleFormChange,
                                          setOpenRecurranceEndDatePicker,
                                          formData,
                                          Email,
                                          setFormData,
                                          filteredOptionalEmployeeData,
                                          setFilteredToEmployeeData,
                                          selectAllChecked,
                                          setFilteredControllRef,
                                          setDailyRecurrancePattern,
                                          monthNames,
                                          Currentdate,
                                          setRecurranceErrors,
                                          setMonthlyRecDayVal,
                                          dailyRecurrancePattern,
                                          setAllDaySelected,
                                          setFormErrors,
                                          setFailMessage,
                                          setOpenFailModal,
                                          isStartTimeGreaterThanEndTime,
                                          validateInput,
                                          isControlRefOpened
                                        );
                                        setOpenRecurranceEndDatePicker(false);
                                      }}

                                      disabled={disableRec}
                                      // readOnly={flow == "UpcomingMeetings" || flow == "CancelledMeetings"}
                                      dateFormat='EEEE dd-MM-yyyy'
                                    />
                                    {/* )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="recurrance-buttons">
                            {!disableRec && (
                              <>
                                <button
                                  type="button"
                                  className="removeBtn btn"
                                  onClick={() => handleRemoveRecurrence("regularRecurrance")}
                                >
                                  Remove Recurrance
                                </button>
                                <button
                                  type="button"
                                  className="setBtn btn"
                                  onClick={() => {
                                    handleOkRecurrence({
                                      formData: formData,
                                      monthlyRecurrancePattern: monthlyRecurrancePattern,
                                      yearlyRecurrancePattern: yearlyRecurrancePattern,
                                      weekGaps: weekGaps,
                                      monthNames: monthNames,
                                      token: token,
                                      Url: Url,
                                      setIsRecurranceSelected: setIsRecurranceSelected,
                                      setFormErrors: setFormErrors,
                                      setRememberValues: setRememberValues,
                                      setRecPatternString: setRecPatternString,
                                      handlerecurranceCloseOk: handlerecurranceCloseOk,
                                      validateRecurrance: validateRecurrance,
                                      dailyRecurrancePattern, setRecurranceErrors
                                    });
                                  }}

                                >
                                  OK
                                </button>
                              </>
                            )}
                            {disableRec && (
                              <>
                                <button
                                  type="button"
                                  className="removeBtn btn"
                                  onClick={() => handleRemoveRecurrence("editRecurrance")}
                                >
                                  Remove Recurrance
                                </button>
                                <button
                                  type="button"
                                  className="setBtn btn"
                                  disabled
                                  style={{ background: "#919191" }}
                                >
                                  OK
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="meeting-name-container"
              style={{
                marginTop:
                  formErrors.deptTagId ||
                    formErrors.meetingLocation ||
                    formErrors.complianceId
                    ? "30px"
                    : "",
              }}
            >
              <div className="field-label">
                Control Ref<span style={{ color: "red" }}>*</span>:
              </div>
              <div className="cref-container-setup" style={{ width: "100%", position: !recurringPop && "relative" }} ref={crefContainerRef} >
                <div
                  className="cref-container-setup"
                  style={{
                    width: "100%",
                    minHeight: "34px",
                    maxHeight: "80px",
                    overflowY: "scroll",
                    border: "1px solid #AFAFAF",
                    borderRadius: "5px",
                    marginLeft: "1px",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: "0 10px",
                    fontSize: "13px",
                  }}
                  data-testid="setOpenControlRefDropDown"
                  onClick={() => {
                    // openModal()
                    (!openControlRefDropDown && !recurringPop) && setOpenControlRefDropDown(true);
                  }}
                >
                  {
                    formData?.controlRefMaster?.filter((item) => item?.isSelected)?.length == 0 ?
                      <p style={{ fontSize: "13px" }}>Select Control Ref</p>
                      :
                      formData?.controlRefMaster?.map((i, index) => {
                        return (
                          i.isSelected && (
                            <div
                              key={index}
                              className="c-ref-item"
                              style={{ cursor: "pointer", margin: "2px", fontSize: "12px", display: 'flex', gap: '0px', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#E6E6E6', }}

                            >
                              <div style={{ display: 'flex', alignItems: 'center', height: "21px", backgroundColor: '#E6E6E6', paddingRight: '8px', paddingLeft: '5px' }}> {i.controlRefNo} : {i.controlRefShort}</div>
                              {/* &nbsp;&nbsp; x */}
                              <div style={{ paddingBottom: '2px' }} className="c-ref-cancel-btn" onClick={() =>
                                handleRemoveControllRef(i.controlRefId, setFilteredControllRef, setFormData, filteredControllRef, formData)
                              }> x </div>
                            </div>
                          )
                        );
                      })}

                  {openControlRefDropDown && (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: 228,
                        // border: "1px solid black",
                        // top: 36,
                        bottom: -229,
                        left: 1,
                        zIndex: 50,
                        padding: 5,
                        backgroundColor: "white",
                        boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                        borderRadius: 5
                      }}
                    >
                      <div style={{ width: "100%", height: 20 }}>
                        <span
                          data-testid="handleCloseControllRefDropdown1"
                          onClick={() => handleCloseControllRefDropdown()}
                          style={{
                            float: "right",
                            cursor: "pointer",
                            padding: "3px"
                          }}
                        >
                          <AiOutlineClose
                            size={"17px"}
                            fill="#00ADEE"
                          />
                        </span>
                      </div>

                      <div className="serch-box-container" style={{ margin: 0, width: "100%" }}>
                        <BsSearch style={{ alignSelf: "center" }} />
                        <input
                          type=""
                          name=""
                          data-testid="controllFilterInpBsSearch"
                          value={controllFilterInp}
                          placeholder="Search"
                          onChange={(e) => handleControllRefSearch(e, setControllFilterInp, formData, setFilteredControllRef)}

                        />
                      </div>
                      <div
                        style={{
                          width: "100%",
                          height: "70%",
                          border: "1px solid black",
                          marginTop: 5,
                          borderRadius: 5,
                          borderColor: "#BCBCBC",
                        }}
                      >
                        <div
                          className="drop-down-opt"
                          style={{ borderBottom: "1px solid #00ADEE", paddingBottom: "4px" }}
                        >
                          <input
                            type="checkbox"
                            name=""
                            data-testid="controllFilterInpCheckbox1"
                            checked={selectAllChecked}
                            onChange={() => {
                              handleSelectAll(setSelectAllChecked,selectAllChecked);
                            }}
                          />
                          <div style={{ color: "#00ADEE" }}>Select All</div>
                        </div>
                        <div className="list-sceoll-view">
                          {filteredControllRef?.map((item, index) => {
                            return (
                              <div key={index} className="drop-down-opt">
                                <input
                                  type="checkbox"
                                  name=""
                                  checked={item.isSelected}
                                  onChange={() =>
                                    handleRefChange(
                                      item.controlRefId,
                                      handleFormChange,
                                      setControllRefOpened,
                                      formData,
                                      Email,
                                      setFormData,
                                      filteredOptionalEmployeeData,
                                      setFilteredToEmployeeData,
                                      selectAllChecked,
                                      setFilteredControllRef,
                                      setDailyRecurrancePattern,
                                      monthNames,
                                      Currentdate,
                                      setRecurranceErrors,
                                      setMonthlyRecDayVal,
                                      dailyRecurrancePattern,
                                      setAllDaySelected,
                                      setFormErrors,
                                      setFailMessage,
                                      setOpenFailModal,
                                      isStartTimeGreaterThanEndTime,
                                      validateInput,
                                      isControlRefOpened
                                    )
                                  }
                                />
                                <div>
                                  {item.controlRefNo} : {item.controlRefShort}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {(formErrors?.controlRefMaster && !openControlRefDropDown) && (
                  <div
                    style={{ width: "100%", textAlign: "left" }}
                    className="form-error"
                  >
                    {formErrors?.controlRefMaster}
                  </div>
                )}
              </div>
            </div>

            <div className="agenda-container">
              <label className="field-label">Agenda:</label>

              <ReactQuill
                name="meetingAgenda"
                id="meetingAgenda"
                value={formData.meetingAgenda}
                onChange={(e) => {
                  handleFormChange("meetingAgenda", e);
                }}
                modules={module}
              >

              </ReactQuill>
            </div>
            <div className="agenda-container">
              <label className="field-label"></label>
              {formErrors?.meetingAgenda &&
                <div
                  style={{ width: "100%", textAlign: "left" }}
                  className="form-error"
                >
                  {formErrors?.meetingAgenda}
                </div>
              }
            </div>

            <div className="agenda-container" style={{ marginBottom: "10px" }}>
              <label className="field-label">Message:</label>
              {/* <textarea
                style={{ padding: "8px", resize: "none" }}
                className="agenda-text"
                name="message"
                id="meetingMessage"
                value={formData.message}
                onChange={(e) => { handleFormChange("message", e); }}
              ></textarea> */}
              <ReactQuill
                name="message"
                id="meetingMessage"
                value={formData.message}
                onChange={(e) => {
                  handleFormChange("message", e);
                }}
                modules={module}

              >
              </ReactQuill>
            </div>
            <div className="agenda-container">
              <label className="field-label"></label>
              {formErrors?.message &&
                <div
                  style={{ width: "100%", textAlign: "left" }}
                  className="form-error"
                >
                  {formErrors?.message}
                </div>
              }
            </div>
            <div className="agenda-container last-field">
              <label className="field-label">Attachments:</label>
              {/* <textarea className='agenda-text'></textarea> */}
              <FileUpload
                formData={formData}
                handleFormChange={handleFormChange}
                setFormData={setFormData}
                flow={flow}
                actualData={actualData}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------------------------Controll Ref Modal----------------------------------------------------------------------- */}
      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={()=>closeModal(setIsOpen)}
        style={modalCss}
        contentLabel="Example Modal"
      >
        <div id="custom-reference-modal">
          <h3>Control Reference</h3>
          <div className="selected-ref-container">
            {formData?.controlRefMaster?.map((i, index) => {
              return (
                i.isSelected && (
                  <div
                    key={index}
                    className="c-ref-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRemoveControllRef(i.controlRefId, setFilteredControllRef, setFormData, filteredControllRef, formData)}
                  >
                    {i.controlRefNo} : {i.controlRefShort} &nbsp;&nbsp; x
                  </div>
                )
              );
            })}
          </div>
          <div
            style={{ borderBottom: "1px solid #CBC2C2", margin: "15px 0px" }}
          ></div>
          <div className="control-ref-main-div">
            <div className="serch-box-container">
              <BsSearch />
              <input
                type=""
                name=""
                value={controllFilterInp}
                placeholder="Search"
                onChange={(e) => handleControllRefSearch(e, setControllFilterInp, formData, setFilteredControllRef)}
              />
            </div>
            <div
              className="drop-down-opt"
              style={{ borderBottom: "1px solid #00ADEE" }}
            >
              <input
                type="checkbox"
                name=""
                checked={selectAllChecked}
                onChange={() => {
                  handleSelectAll(setSelectAllChecked,selectAllChecked);
                }}
              />
              <div style={{ color: "#00ADEE" }}>Select All</div>
            </div>
            <div className="list-sceoll-view">
              {filteredControllRef?.map((item, index) => {
                return (
                  <div key={index} className="drop-down-opt">
                    <input
                      type="checkbox"
                      name=""
                      checked={item.isSelected}
                      onChange={() =>
                        handleRefChange(
                          item.controlRefId,
                          handleFormChange,
                          setControllRefOpened,
                          formData,
                          Email,
                          setFormData,
                          filteredOptionalEmployeeData,
                          setFilteredToEmployeeData,
                          selectAllChecked,
                          setFilteredControllRef,
                          setDailyRecurrancePattern,
                          monthNames,
                          Currentdate,
                          setRecurranceErrors,
                          setMonthlyRecDayVal,
                          dailyRecurrancePattern,
                          setAllDaySelected,
                          setFormErrors,
                          setFailMessage,
                          setOpenFailModal,
                          isStartTimeGreaterThanEndTime,
                          validateInput,
                          isControlRefOpened
                        )
                      } />
                    <div>
                      {item.controlRefNo} : {item.controlRefShort}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="done-btn-container">
            <button
              name="controlRefMaster"
              className=""
              type="button"
              onClick={() => setIsOpen(false)}
            >
              Done
            </button>
          </div>
          <AiOutlineClose
            className="controll-ref-close"
            fill="#00ADEE"
            onClick={() => closeModal(setIsOpen)}
          />
        </div>
      </Modal>
      {/* ----------------------------------------------------------------------Controll Ref Modal Close----------------------------------------------------------------------- */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>navigateAfterSubmit(navigate)}
        recallFunctionOnClose={()=>navigateAfterSubmit(navigate)}
      />

      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal,setFailMessage)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal,setFailMessage)}
      />
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive) }
        recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive) }
      />
    </form>
  );
};

export default SetUpMeeting











